// Space Social Storefront JavaScript Logic

(function () {
    const isLocal = window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.protocol === "file:";
    if (!isLocal) return; // Do not run redirect lock on Shopify production

    const isPasswordPage = window.location.pathname.endsWith("password.html") ||
        window.location.pathname.endsWith("password");
    const isAuthorized = localStorage.getItem("storefront_authorized") === "true";
    if (!isPasswordPage && !isAuthorized) {
        window.location.href = "password.html";
    }
})();

window.isPruneModeActive = false;
window.quickCartItems = [];
window.hiddenCardIds = new Set();
let globalUniqueCardCounter = 0;

function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function formatPrice(amount) {
    const num = Number(amount);
    if (isNaN(num) || num === null || num === undefined) return '$0.00';
    return `$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function safeParseShopifyProductsJson(rawText) {
    if (!rawText || !rawText.trim()) return [];
    // Strip BOM or zero-width spaces
    const trimmed = rawText.trim().replace(/^[\uFEFF\xA0]+|[\uFEFF\xA0]+$/g, '');
    try {
        return JSON.parse(trimmed);
    } catch (initialErr) {
        // Attempt intelligent repair for corrupted Liquid JSON output
        let repaired = trimmed;

        // 1. Missing opening '{' right after '[': e.g. '[\n  "id":' -> '[\n  {\n  "id":'
        repaired = repaired.replace(/^\[\s*("id"\s*:)/m, '[\n{\n$1');

        // 2. Missing opening '{' between objects: e.g. '}\s*,\s*"id":' -> '},\n{\n$1'
        repaired = repaired.replace(/\}\s*,\s*("id"\s*:)/g, '},\n{\n$1');

        // 3. Objects where closing brace was omitted before comma: e.g. ']\s*,\s*"id":' -> ']\n},\n{\n$1'
        repaired = repaired.replace(/\]\s*,\s*("id"\s*:)/g, ']\n},\n{\n$1');

        // 4. Missing final closing '}' before closing ']'
        if (!/\}\s*\]\s*$/.test(repaired) && /\]\s*\]\s*$/.test(repaired)) {
            repaired = repaired.replace(/\]\s*\]\s*$/, ']\n}\n]');
        } else if (!/\}\s*\]\s*$/.test(repaired) && /\]\s*$/.test(repaired)) {
            repaired = repaired.replace(/([^\s\}\]])\s*\]\s*$/, '$1\n}\n]');
        }

        // 5. Trailing commas before closing bracket/brace
        repaired = repaired.replace(/,\s*([\]\}])/g, '$1');

        try {
            const repairedResult = JSON.parse(repaired);
            console.warn("Shopify products JSON was automatically repaired from malformed Liquid output.");
            return repairedResult;
        } catch (repairErr) {
            console.error("Could not auto-repair Shopify products JSON:", repairErr);
            throw initialErr;
        }
    }
}

function fallbackCopyText(text) {
    try {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        textarea.style.top = "-9999px";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textarea);
        return successful;
    } catch (err) {
        return false;
    }
}

function copyTextToClipboard(text) {
    if (!text) return Promise.resolve(false);
    if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        return navigator.clipboard.writeText(text).then(() => true).catch(() => {
            return fallbackCopyText(text);
        });
    }
    return Promise.resolve(fallbackCopyText(text));
}

window.hideCardFromCatalog = function (cardId, event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    if (cardId !== undefined && cardId !== null) {
        window.hiddenCardIds.add(cardId);
        window.hiddenCardIds.add(String(cardId));
    }
    if (typeof renderTCGGrid === "function") {
        renderTCGGrid();
    }
};

// --- INVENTORY AUDIT & CHECK TIMESTAMP SYSTEM (ADMIN MODE) ---
window.inventoryAuditData = {};
window.isInventoryCheckModeActive = false;
let exportedInventoryAuditSnapshot = JSON.stringify(window.inventoryAuditData);

function warnAboutUnexportedInventoryAudit(event) {
    event.preventDefault();
    event.returnValue = "";
    if (typeof showToast === "function") {
        showToast("Export Inventory Check", "Your inventory check has unexported changes. Choose Stay, then use Export in the admin panel to save them.", "warning");
    }
}

function updateInventoryAuditExportWarning() {
    const hasUnexportedChanges = JSON.stringify(window.inventoryAuditData) !== exportedInventoryAuditSnapshot;
    if (hasUnexportedChanges) {
        window.addEventListener("beforeunload", warnAboutUnexportedInventoryAudit);
    } else {
        window.removeEventListener("beforeunload", warnAboutUnexportedInventoryAudit);
    }
}

function saveInventoryAuditCookie() {
    // Inventory audit data is kept in memory per session and loaded/saved via JSON file import/export (no cookies used).
    updateInventoryAuditExportWarning();
    renderInventoryOverchecks();
}

function loadInventoryAuditCookie() {
    window.inventoryAuditData = window.inventoryAuditData || {};
}

loadInventoryAuditCookie();

function getInventoryOverchecks() {
    const rows = [];
    const shortConditions = { 'Near Mint': 'NM', 'Lightly Played': 'LP', 'Moderately Played': 'MP', 'Heavily Played': 'HP', 'Damaged': 'DMG' };
    for (const card of (typeof tcgInventory !== "undefined" && tcgInventory) || []) {
        const record = window.getInventoryAuditRecord(card.id || card._uniqueId);
        if (!record) continue;
        for (const [condition, check] of Object.entries(record.conditions || {})) {
            let stock = Number(card.stock) || 0;
            if (card.variants && card.variants.length) {
                const variant = card.variants.find(v => {
                    const canonical = typeof normalizeCondition === "function" ? normalizeCondition(v.option1) : v.option1;
                    return (shortConditions[canonical] || canonical || v.option1 || 'Default') === condition || v.option1 === condition;
                });
                stock = Number(variant && variant.stock) || 0;
            }
            stock = Math.max(0, stock);
            const checked = Number(check && check.checkedCount) || 0;
            if (checked > stock) rows.push({ name: card.name || `Product #${card.id}`, condition, checked, stock, excess: checked - stock });
        }
    }
    return rows.sort((a, b) => b.excess - a.excess || a.name.localeCompare(b.name));
}

function renderInventoryOverchecks() {
    const panel = document.querySelector('.admin-audit-panel');
    if (!panel) return;
    let report = document.getElementById('admin-inventory-overchecks');
    if (!report) {
        report = document.createElement('section');
        report.id = 'admin-inventory-overchecks';
        report.className = 'admin-inventory-overchecks';
        panel.appendChild(report);
    }
    const rows = getInventoryOverchecks();
    report.innerHTML = `
        <h5>Checks above inventory (${rows.length})</h5>
        <p>Imports add to existing counts. Importing the same file again adds those checks again.</p>
        ${rows.length ? `<div class="admin-overchecks-scroll"><table>
            <thead><tr><th>Product / condition</th><th>Checked</th><th>Stock</th><th>Extra</th></tr></thead>
            <tbody>${rows.map(row => `<tr><td>${escapeHtml(row.name)}<br><strong>${escapeHtml(row.condition)}</strong></td><td>${row.checked}</td><td>${row.stock}</td><td>+${row.excess}</td></tr>`).join('')}</tbody>
        </table></div>` : '<p>No checked quantities exceed inventory.</p>'}`;
}

window.toggleInventoryCheckMode = function (enabled) {
    window.isInventoryCheckModeActive = !!enabled;
    localStorage.setItem("ss_inventory_check_mode_active", window.isInventoryCheckModeActive ? "true" : "false");
    if (typeof showToast === "function") {
        showToast(
            window.isInventoryCheckModeActive ? "Check Mode Active" : "Check Mode Disabled",
            window.isInventoryCheckModeActive ? "Clicking product condition pills will now mark items checked." : "Clicking product condition pills will now add items to quick cart.",
            "info"
        );
    }
    if (typeof renderTCGGrid === "function") {
        renderTCGGrid(false);
    }
};

window.isHideFullyCheckedActive = false;

window.toggleHideFullyChecked = function (enabled) {
    window.isHideFullyCheckedActive = !!enabled;
    localStorage.setItem("ss_hide_fully_checked_active", window.isHideFullyCheckedActive ? "true" : "false");
    if (typeof showToast === "function") {
        showToast(
            window.isHideFullyCheckedActive ? "Hide Fully Checked Active" : "Showing All Products",
            window.isHideFullyCheckedActive ? "Hiding products where all in-stock conditions are fully checked." : "Showing all products including fully checked items.",
            "info"
        );
    }
    if (typeof renderTCGGrid === "function") {
        renderTCGGrid();
    }
};

window.isProductFullyChecked = function (card) {
    if (!card) return false;
    const strId = String(card.id || card._uniqueId);
    const auditRecord = window.getInventoryAuditRecord ? window.getInventoryAuditRecord(strId) : null;
    if (!auditRecord) return false;

    const CONDITION_SHORT = {
        'Near Mint': 'NM', 'Lightly Played': 'LP', 'Moderately Played': 'MP', 'Heavily Played': 'HP', 'Damaged': 'DMG'
    };

    if (card.variants && card.variants.length > 0) {
        const inStockVariants = card.variants.filter(v => (v.stock !== undefined ? v.stock : 0) > 0);
        if (inStockVariants.length === 0) return false;

        return inStockVariants.every(v => {
            const canonical = typeof normalizeCondition === "function" ? normalizeCondition(v.option1) : v.option1;
            const condLabel = canonical ? (CONDITION_SHORT[canonical] || canonical) : (v.option1 || 'Default');
            const condRec = auditRecord.conditions && auditRecord.conditions[condLabel] ? auditRecord.conditions[condLabel] : null;
            const checkedCnt = condRec ? (condRec.checkedCount || 0) : 0;
            const vStock = v.stock !== undefined ? v.stock : 0;
            return checkedCnt >= vStock;
        });
    } else {
        const cardStock = card.stock !== undefined ? card.stock : 0;
        if (cardStock <= 0) return false;
        const condLabel = card.bgsGrade ? `BGS ${card.bgsGrade}` : (card.psa && card.psa !== "Raw" && card.psa !== "Sealed" ? `PSA ${card.psa}` : (card.condition || 'Raw'));
        const condRec = auditRecord.conditions && auditRecord.conditions[condLabel] ? auditRecord.conditions[condLabel] : null;
        const checkedCnt = condRec ? (condRec.checkedCount || 0) : (auditRecord.totalCheckCount || 0);
        return checkedCnt >= cardStock;
    }
};

window.handleAdminCondItemClick = function (cardId, conditionKey, variantId, event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    if (window.isInventoryCheckModeActive) {
        window.markConditionChecked(cardId, conditionKey, variantId, event);
    } else {
        window.addVariantToQuickCart(cardId, variantId, event);
    }
};

function handleAdminConditionClick(e) {
    // Cond minus button
    const condMinusBtn = e.target.closest(".cond-minus-btn");
    if (condMinusBtn) {
        e.stopPropagation();
        e.preventDefault();
        const cardId = condMinusBtn.getAttribute("data-card-id");
        const condLabel = condMinusBtn.getAttribute("data-cond-label");
        if (cardId && condLabel && window.decrementConditionChecked) {
            window.decrementConditionChecked(cardId, condLabel, e);
        }
        return;
    }

    // Admin Condition Item Click (Check Mode / Add variant to Quick Cart)
    const adminCondItem = e.target.closest(".admin-cond-item");
    if (adminCondItem) {
        e.stopPropagation();
        e.preventDefault();
        if (adminCondItem.getAttribute("data-disabled") === "true") return;
        const cardId = adminCondItem.getAttribute("data-card-id");
        const condLabel = adminCondItem.getAttribute("data-cond-label");
        const variantIdStr = adminCondItem.getAttribute("data-variant-id");
        const variantId = variantIdStr ? parseInt(variantIdStr, 10) : null;
        if (window.handleAdminCondItemClick) {
            window.handleAdminCondItemClick(cardId, condLabel, variantId, e);
        }
        return;
    }
}

window.getInventoryAuditRecord = function (productId) {
    if (productId === undefined || productId === null) return null;
    const strId = String(productId);
    const numId = Number(productId);

    let raw = window.inventoryAuditData[strId];
    if (!raw && !isNaN(numId)) {
        raw = window.inventoryAuditData[numId];
    }
    if (!raw) {
        for (const [k, v] of Object.entries(window.inventoryAuditData || {})) {
            if (String(k) === strId) {
                raw = v;
                break;
            }
        }
    }
    if (!raw) return null;
    if (typeof raw === 'string') {
        return {
            timestamp: raw,
            status: 'found',
            totalCheckCount: 1,
            conditions: {}
        };
    }
    return {
        timestamp: raw.timestamp || null,
        status: raw.status || 'found',
        totalCheckCount: raw.totalCheckCount !== undefined ? raw.totalCheckCount : (raw.timestamp ? 1 : 0),
        conditions: raw.conditions || {}
    };
};

window.getInventoryAuditTimestamp = function (productId) {
    const rec = window.getInventoryAuditRecord(productId);
    return rec ? rec.timestamp : null;
};

window.markProductInventoryChecked = function (productId, event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    if (!productId) return;
    const strId = String(productId);
    const nowIso = new Date().toISOString();
    const existingRec = window.getInventoryAuditRecord(strId) || {
        timestamp: nowIso,
        status: 'found',
        totalCheckCount: 0,
        conditions: {}
    };

    window.inventoryAuditData[strId] = {
        timestamp: nowIso,
        status: 'found',
        totalCheckCount: (existingRec.totalCheckCount || 0) + 1,
        conditions: existingRec.conditions || {}
    };
    saveInventoryAuditCookie();

    const card = (tcgInventory || []).find(c => (String(c.id) === strId || String(c._uniqueId) === strId));
    const cardName = card ? card.name : `Product #${productId}`;
    if (typeof showToast === "function") {
        showToast("Inventory Verified", `Marked "${cardName}" checked in stock at ${window.formatAuditTimeShort(nowIso)}`, "success");
    }

    if (typeof renderTCGGrid === "function") {
        renderTCGGrid(false);
    }
};

window.markConditionChecked = function (productId, conditionKey, variantId, event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    if (!productId) return;
    const strId = String(productId);
    const nowIso = new Date().toISOString();

    const card = (typeof tcgInventory !== "undefined" && tcgInventory) ? tcgInventory.find(c => (String(c.id) === strId || String(c._uniqueId) === strId)) : null;
    const cardName = card ? card.name : `Product #${productId}`;

    let maxStock = 1;
    if (card) {
        if (card.variants && card.variants.length > 0) {
            let foundV = null;
            if (variantId) {
                foundV = card.variants.find(v => String(v.id) === String(variantId));
            }
            if (!foundV && conditionKey) {
                const CONDITION_SHORT = {
                    'Near Mint': 'NM', 'Lightly Played': 'LP', 'Moderately Played': 'MP', 'Heavily Played': 'HP', 'Damaged': 'DMG'
                };
                foundV = card.variants.find(v => {
                    const canonical = typeof normalizeCondition === "function" ? normalizeCondition(v.option1) : v.option1;
                    const condLabel = canonical ? (CONDITION_SHORT[canonical] || canonical) : (v.option1 || 'Default');
                    return condLabel === conditionKey || v.option1 === conditionKey;
                });
            }
            if (foundV && foundV.stock !== undefined) {
                maxStock = Math.max(1, foundV.stock);
            }
        } else if (card.stock !== undefined) {
            maxStock = Math.max(1, card.stock);
        }
    }

    const record = window.getInventoryAuditRecord(strId) || {
        timestamp: nowIso,
        status: 'found',
        totalCheckCount: 0,
        conditions: {}
    };

    if (!record.conditions) record.conditions = {};
    const condKey = conditionKey || 'Default';
    if (!record.conditions[condKey]) {
        record.conditions[condKey] = { checkedCount: 0, lastChecked: nowIso };
    }

    const currentChecked = record.conditions[condKey].checkedCount || 0;
    let newCount = currentChecked;
    let toastTitle = "Condition Checked";
    let toastMessage = "";

    if (currentChecked < maxStock) {
        newCount = currentChecked + 1;
        record.totalCheckCount = (record.totalCheckCount || 0) + 1;
        toastMessage = `Marked "${cardName}" [${condKey}] checked (${newCount}/${maxStock})`;
    } else {
        // Preserve excess counts imported from another checking session.
        newCount = currentChecked;
        toastTitle = "Timestamp Updated";
        toastMessage = `Updated check timestamp for "${cardName}" [${condKey}] (${newCount}/${maxStock} checked)`;
    }

    record.conditions[condKey].checkedCount = newCount;
    record.conditions[condKey].lastChecked = nowIso;
    record.timestamp = nowIso;
    record.status = 'found';

    window.inventoryAuditData[strId] = record;
    saveInventoryAuditCookie();

    if (typeof showToast === "function") {
        showToast(toastTitle, toastMessage, "success");
    }

    if (typeof renderTCGGrid === "function") {
        renderTCGGrid(false);
    }
};

window.decrementConditionChecked = function (productId, conditionKey, event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    if (!productId) return;
    const strId = String(productId);

    const record = window.getInventoryAuditRecord(strId);
    if (!record || !record.conditions) return; // Cannot subtract if no check at all

    const condKey = conditionKey || 'Default';
    const condRec = record.conditions[condKey];
    if (!condRec || (condRec.checkedCount || 0) <= 0) {
        // Cannot subtract if no check at all for this condition
        return;
    }

    condRec.checkedCount -= 1;
    record.totalCheckCount = Math.max(0, (record.totalCheckCount || 1) - 1);

    if (condRec.checkedCount <= 0) {
        delete record.conditions[condKey];
    }

    const remainingKeys = Object.keys(record.conditions);
    if (remainingKeys.length === 0) {
        if (record.status !== 'cant_find') {
            record.timestamp = null;
            record.totalCheckCount = 0;
        }
    } else {
        let newestTs = null;
        for (const c of Object.values(record.conditions)) {
            if (c.lastChecked && (!newestTs || new Date(c.lastChecked) > new Date(newestTs))) {
                newestTs = c.lastChecked;
            }
        }
        if (newestTs) record.timestamp = newestTs;
    }

    if (!record.timestamp && remainingKeys.length === 0 && record.status !== 'cant_find') {
        delete window.inventoryAuditData[strId];
    } else {
        window.inventoryAuditData[strId] = record;
    }

    saveInventoryAuditCookie();

    const card = (tcgInventory || []).find(c => (String(c.id) === strId || String(c._uniqueId) === strId));
    const cardName = card ? card.name : `Product #${productId}`;
    const remCount = condRec ? (condRec.checkedCount || 0) : 0;

    if (typeof showToast === "function") {
        showToast("Check Decremented", `Removed check for "${cardName}" [${condKey}] (${remCount} remaining)`, "info");
    }

    if (typeof renderTCGGrid === "function") {
        renderTCGGrid(false);
    }
};

window.markProductCantFind = function (productId, event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    if (!productId) return;
    const strId = String(productId);
    const nowIso = new Date().toISOString();
    const existingRec = window.getInventoryAuditRecord(strId) || {
        timestamp: nowIso,
        status: 'cant_find',
        totalCheckCount: 0,
        conditions: {}
    };

    window.inventoryAuditData[strId] = {
        timestamp: nowIso,
        status: 'cant_find',
        totalCheckCount: (existingRec.totalCheckCount || 0) + 1,
        conditions: existingRec.conditions || {}
    };
    saveInventoryAuditCookie();

    const card = (tcgInventory || []).find(c => (String(c.id) === strId || String(c._uniqueId) === strId));
    const cardName = card ? card.name : `Product #${productId}`;
    if (typeof showToast === "function") {
        showToast("Marked Can't Find", `Flagged "${cardName}" as Can't Find in inventory.`, "warning");
    }

    if (typeof renderTCGGrid === "function") {
        renderTCGGrid(false);
    }
};

window.formatAuditTimeShort = function (isoString) {
    if (!isoString) return "Never Checked";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return "Never Checked";

    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;

    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

window.formatAuditTime = function (isoString) {
    if (!isoString) return "Never Checked";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return "Never Checked";
    return date.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    });
};

let inventoryAuditExportInProgress = false;

window.exportInventoryAuditData = async function () {
    if (inventoryAuditExportInProgress) return;
    inventoryAuditExportInProgress = true;
    try {
        // Keep edits made while the share sheet is open marked as unexported.
        const exportSnapshot = JSON.stringify(window.inventoryAuditData);
        const cleanAuditData = {};
        let exportCount = 0;

        for (const [prodId, rec] of Object.entries(window.inventoryAuditData || {})) {
            // Must exist in current tcgInventory
            const card = (typeof tcgInventory !== "undefined" && tcgInventory) ? tcgInventory.find(c => String(c.id) === String(prodId) || String(c._uniqueId) === String(prodId)) : null;
            if (!card) continue; // Exclude products that no longer exist

            const isCantFind = rec && rec.status === "cant_find";
            const validConditions = {};

            if (rec && rec.conditions && Object.keys(rec.conditions).length > 0) {
                for (const [condKey, condRec] of Object.entries(rec.conditions)) {
                    if (!condRec || (condRec.checkedCount || 0) <= 0) continue;

                    validConditions[condKey] = condRec;
                }
            }

            if (Object.keys(validConditions).length > 0 || isCantFind) {
                cleanAuditData[prodId] = {
                    ...rec,
                    conditions: validConditions
                };
                exportCount++;
            }
        }

        const exportPayload = {
            appName: "SpaceSocialTCG",
            exportType: "InventoryAuditData",
            version: "1.3",
            exportedAt: new Date().toISOString(),
            totalChecked: exportCount,
            auditData: cleanAuditData
        };

        const filename = `inventory_audit_${new Date().toISOString().slice(0, 10)}.json`;
        const blob = new Blob([JSON.stringify(exportPayload, null, 2)], { type: "application/json" });
        const file = typeof File === "function" ? new File([blob], filename, { type: "application/json" }) : null;
        const useShareSheet = navigator.maxTouchPoints > 0 && file &&
            typeof navigator.share === "function" && typeof navigator.canShare === "function" &&
            navigator.canShare({ files: [file] });

        if (useShareSheet) {
            if (typeof showToast === "function") {
                showToast("Save Inventory Check", "Choose Save to Files in the share sheet to save your audit JSON file.", "info");
            }
            await navigator.share({ files: [file] });
        } else {
            const objectUrl = URL.createObjectURL(blob);
            const downloadAnchor = document.createElement('a');
            downloadAnchor.setAttribute("href", objectUrl);
            downloadAnchor.setAttribute("download", filename);
            downloadAnchor.setAttribute("target", "_blank");
            downloadAnchor.setAttribute("rel", "noopener");
            document.body.appendChild(downloadAnchor);
            try {
                downloadAnchor.click();
            } finally {
                // Safari may consume the file after the click handler returns.
                setTimeout(() => {
                    downloadAnchor.remove();
                    URL.revokeObjectURL(objectUrl);
                }, 60000);
            }
        }
        exportedInventoryAuditSnapshot = exportSnapshot;
        updateInventoryAuditExportWarning();

        if (typeof showToast === "function") {
            showToast(useShareSheet ? "Audit Shared" : "Download Started", `${exportCount} inventory check records. ${useShareSheet ? "Keep the JSON file to restore your checks later." : "Check your browser downloads for the JSON file."}`, "success");
        }
    } catch (e) {
        if (e.name === "AbortError") {
            if (typeof showToast === "function") {
                showToast("Export Canceled", "Your checks are still here. Tap Export and choose Save to Files to save them.", "info");
            }
            return;
        }
        console.error("Failed to export audit data:", e);
        if (typeof showToast === "function") {
            showToast("Export Error", e.message, "error");
        }
    } finally {
        inventoryAuditExportInProgress = false;
    }
};

window.importInventoryAuditData = function (event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = function (e) {
        try {
            const parsed = JSON.parse(e.target.result);
            let importedData = {};
            if (parsed && parsed.auditData && typeof parsed.auditData === 'object') {
                importedData = parsed.auditData;
            } else if (parsed && typeof parsed === 'object') {
                importedData = parsed;
            } else {
                throw new Error("Invalid audit file format.");
            }


            let updatedCount = 0;
            const ignoredItemsList = [];

            for (const [prodId, impVal] of Object.entries(importedData)) {
                // Find matching card in current inventory
                const card = (typeof tcgInventory !== "undefined" && tcgInventory) ? tcgInventory.find(c => String(c.id) === String(prodId) || String(c._uniqueId) === String(prodId)) : null;

                if (!card) {
                    const itemName = (typeof impVal === 'object' && impVal.name) ? impVal.name : `Product ID #${prodId}`;
                    ignoredItemsList.push({ id: prodId, name: itemName });
                    continue; // Ignore non-existent product!
                }

                const curRec = window.getInventoryAuditRecord(prodId);
                const rawImpRec = (typeof impVal === 'string') 
                    ? { timestamp: impVal, status: 'found', totalCheckCount: 1, conditions: {} }
                    : {
                        timestamp: impVal.timestamp || null,
                        status: impVal.status || 'found',
                        totalCheckCount: impVal.totalCheckCount || 0,
                        conditions: impVal.conditions || {}
                    };

                // Preserve imported quantities, including excess and zero-stock checks.
                const validImpConditions = {};
                for (const [condKey, condVal] of Object.entries(rawImpRec.conditions || {})) {
                    const count = Number(condVal && condVal.checkedCount);
                    if (Number.isSafeInteger(count) && count > 0) {
                        validImpConditions[condKey] = { ...condVal, checkedCount: count };
                    }
                }

                const isCantFind = rawImpRec.status === 'cant_find';
                if (Object.keys(validImpConditions).length === 0 && !isCantFind) {
                    // Skip records with no positive condition counts unless flagged missing.
                    continue;
                }

                const impRec = {
                    ...rawImpRec,
                    conditions: validImpConditions
                };

                if (!curRec) {
                    impRec.totalCheckCount = Object.values(validImpConditions).reduce((sum, c) => sum + c.checkedCount, 0);
                    window.inventoryAuditData[prodId] = impRec;
                    updatedCount++;
                } else {
                    const curTime = curRec.timestamp ? new Date(curRec.timestamp).getTime() : 0;
                    const impTime = impRec.timestamp ? new Date(impRec.timestamp).getTime() : 0;

                    // Deep merge condition check counts and timestamps
                    const mergedConditions = { ...curRec.conditions };
                    for (const [condKey, impCond] of Object.entries(impRec.conditions || {})) {
                        const curCond = mergedConditions[condKey];
                        if (!curCond) {
                            mergedConditions[condKey] = impCond;
                        } else {
                            const curCondTime = curCond.lastChecked ? new Date(curCond.lastChecked).getTime() : 0;
                            const impCondTime = impCond.lastChecked ? new Date(impCond.lastChecked).getTime() : 0;
                            mergedConditions[condKey] = {
                                checkedCount: Number(curCond.checkedCount || 0) + impCond.checkedCount,
                                lastChecked: impCondTime >= curCondTime ? impCond.lastChecked : curCond.lastChecked
                            };
                        }
                    }

                    // Recalculate total check count
                    let sumCheckCount = 0;
                    for (const c of Object.values(mergedConditions)) {
                        sumCheckCount += (c.checkedCount || 0);
                    }

                    const newestTs = impTime >= curTime ? impRec.timestamp : curRec.timestamp;
                    const newestStatus = impTime >= curTime ? impRec.status : curRec.status;

                    window.inventoryAuditData[prodId] = {
                        timestamp: newestTs,
                        status: newestStatus,
                        totalCheckCount: sumCheckCount,
                        conditions: mergedConditions
                    };
                    updatedCount++;
                }
            }

            saveInventoryAuditCookie();

            const ignoredCount = ignoredItemsList.length;
            const processedCount = updatedCount;

            if (ignoredCount > 0) {
                const missingListText = ignoredItemsList.slice(0, 10).map(item => `• ${item.name} (${item.id})`).join("\n");
                const moreText = ignoredCount > 10 ? `\n...and ${ignoredCount - 10} more` : '';
                alert(`⚠️ Audit Import Notice:\n\nThe following ${ignoredCount} item(s) in the imported file no longer exist in current inventory and were ignored:\n\n${missingListText}${moreText}`);
            }

            if (typeof showToast === "function") {
                showToast("Audit Imported", `Added checks from ${processedCount} inventory audit records. Importing the same file again adds its quantities again.`, "success");
            }

            if (typeof renderTCGGrid === "function") {
                renderTCGGrid(false);
            }
        } catch (err) {
            console.error("Failed to import audit file:", err);
            if (typeof showToast === "function") {
                showToast("Import Error", "Could not parse audit JSON file.", "error");
            }
        }
        event.target.value = "";
    };
    reader.readAsText(file);
};

// --- TCG & CAFÉ INVENTORY DATABASE ---
const CONDITION_HIERARCHY = ["Near Mint", "Lightly Played", "Moderately Played", "Heavily Played", "Damaged"];

// Flexible condition name aliases — maps abbreviations / alternate names to canonical values
const CONDITION_ALIASES = {
    'near mint': 'Near Mint', 'nm': 'Near Mint', 'nm/m': 'Near Mint', 'mint': 'Near Mint', 'nm+': 'Near Mint', 'm': 'Near Mint',
    'lightly played': 'Lightly Played', 'lp': 'Lightly Played', 'excellent': 'Lightly Played', 'ex': 'Lightly Played', 'light play': 'Lightly Played',
    'moderately played': 'Moderately Played', 'mp': 'Moderately Played', 'good': 'Moderately Played', 'moderate play': 'Moderately Played',
    'heavily played': 'Heavily Played', 'hp': 'Heavily Played', 'poor': 'Heavily Played', 'heavy play': 'Heavily Played',
    'damaged': 'Damaged', 'dmg': 'Damaged', 'd': 'Damaged', 'dam': 'Damaged'
};

/**
 * Normalizes a Shopify variant condition label to a canonical CONDITION_HIERARCHY value.
 * Returns null if the value is not a recognised condition.
 */
function normalizeCondition(val) {
    if (!val) return null;
    const str = val.trim();
    if (CONDITION_HIERARCHY.includes(str)) return str;
    const lower = str.toLowerCase();
    if (CONDITION_ALIASES[lower]) return CONDITION_ALIASES[lower];

    // Regex/substring search for multi-property labels (e.g. "Near Mint / Holofoil", "NM - Foil", "Near Mint (Shiny Ultra Rare)")
    const sortedAliases = Object.keys(CONDITION_ALIASES).sort((a, b) => b.length - a.length);
    for (const alias of sortedAliases) {
        const regex = new RegExp(`(?:^|[\\s/\\-(\\[,])${alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?=$|[\\s/\\-()\\]\\],]|$)`, 'i');
        if (regex.test(lower)) {
            return CONDITION_ALIASES[alias];
        }
    }
    return null;
}

/**
 * Extracts condition from any option field (option1, option2, option3, title) of a variant.
 */
function getVariantCondition(variant) {
    if (!variant) return null;
    return normalizeCondition(variant.option1) ||
           normalizeCondition(variant.option2) ||
           normalizeCondition(variant.option3) ||
           normalizeCondition(variant.title);
}

/**
 * Determines whether a Pokémon product is English or Japanese.
 * - "Pokemon Single" or "Pokemon Sealed" => english
 * - "Pokemon Japanese Single" or "Pokemon Japanese Sealed" => japanese
 */
window.getPokemonLanguage = function (card) {
    if (!card) return 'english';
    const pType = String(card.productType || card.product_type || card.type || '').trim().toLowerCase();

    if (pType === 'pokemon japanese single' || pType === 'pokemon japanese sealed' || pType.includes('japanese')) {
        return 'japanese';
    }
    if (pType === 'pokemon single' || pType === 'pokemon sealed') {
        return 'english';
    }

    const tagsStr = Array.isArray(card.tags) ? card.tags.join(' ').toLowerCase() : String(card.tags || '').toLowerCase();
    const nameStr = String(card.name || '').toLowerCase();

    if (tagsStr.includes('pokemon japanese') || tagsStr.includes('japanese') || nameStr.includes('japanese') || nameStr.includes('[jp]')) {
        return 'japanese';
    }

    return 'english';
};

/**
 * Resolves the BGS slab template background image path for a given grade (e.g. "1", "1.5", "9.5", "10", "11").
 */
function getBgsSlabImage(grade) {
    if (!grade) grade = "10";
    const gradeStr = grade.toString();
    if (window.themeAssets && window.themeAssets.bgsSlabs && window.themeAssets.bgsSlabs[gradeStr]) {
        return window.themeAssets.bgsSlabs[gradeStr];
    }
    const cleanKey = gradeStr.replace('.', '');
    return `assets/bgs${cleanKey}.webp`;
}

// Keep numeric grades for filtering; the Pristine designation selects a separate image.
function parseImageSlabGrade(tags, company) {
    const pattern = new RegExp(`^${company}[\\s_:]*(?:(?:pristine|gem[\\s_-]*mint)[\\s_-]*)?(10|[1-9](?:\\.5)?)(?:$|[\\s_-])`, 'i');
    for (const tag of tags) {
        const match = String(tag).trim().match(pattern);
        if (match) return match[1];
    }
    return null;
}

function getImageSlab(card) {
    const company = card.tagGrade ? 'tag' : (card.cgcGrade ? 'cgc' : null);
    if (!company) return null;
    const grade = String(card[`${company}Grade`]);
    const labels = [grade, card.condition, card.name, ...(card.tags || []),
        ...(card.variants || []).map(variant => variant.title)].filter(Boolean);
    const pristine = parseFloat(grade) === 10 && labels.some(label => /\bpristine\b/i.test(label));
    const key = pristine ? '10-pristine' : grade;
    const supported = company === 'tag'
        ? ['5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '10', '10-pristine']
        : ['1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10-pristine'];
    if (!supported.includes(key)) return null;
    const assets = window.themeAssets && window.themeAssets[`${company}Slabs`];
    return {
        company,
        image: (assets && assets[key]) || `assets/${company}${key.replace('.', '')}.png`,
        label: `${company.toUpperCase()} ${grade}${pristine ? ' Pristine' : ''}`
    };
}

/**
 * Returns the fallback image URL based on the game type.
 */
function getFallbackImage(game) {
    if (game === 'pokemon') {
        return (window.themeAssets && window.themeAssets.heroPokemonCard) || 'assets/hero_pokemon_card.jpg';
    } else if (game === 'onepiece') {
        return (window.themeAssets && window.themeAssets.heroOnepieceCard) || 'assets/hero_onepiece_card.jpg';
    }
    const cardBacks = {
        yugioh: ['yugiohCardBack', 'yugioh-card-back.webp'],
        mtg: ['mtgCardBack', 'mtg-card-back.webp'],
        riftbound: ['riftboundCardBack', 'riftbound-card-back.png']
    };
    if (cardBacks[game]) {
        const [assetKey, filename] = cardBacks[game];
        return (window.themeAssets && window.themeAssets[assetKey]) || `assets/${filename}`;
    }
    return 'https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?w=400&q=80';
}

/**
 * Parses raw Shopify product metadata into a TCG inventory object structure.
 * Returns null if it is a cafe/coffee/tea product.
 */
function isInStoreOnly(product) {
    return (product.tags || []).includes('instoreonly');
}

function parseShopifyProduct(product) {
    // Shopify sets this flag from membership in the Events collection.
    // Apply it here so both the initial catalog and later pages exclude tickets.
    if (product.isEvent === true) return null;

    const tags = product.tags || [];
    const lowerTags = tags.map(t => t.toLowerCase());
    const isCafe = lowerTags.includes('cafe') || lowerTags.includes('coffee') || lowerTags.includes('tea');

    if (isCafe) return null;

    let game = 'pokemon';
    let badgeLabel = null;
    const prodType = (product.type || product.product_type || product.productType || '').toLowerCase().trim();
    if (prodType === 'yugioh single' || prodType === 'yugioh sealed' || prodType.includes('yugioh') || prodType.includes('yu-gi-oh') || lowerTags.some(t => t.includes('yugioh') || t.includes('yu-gi-oh') || t.includes('yugi') || t.includes('brand_yugioh'))) {
        game = 'yugioh';
        badgeLabel = 'Yu-Gi-Oh!';
    } else if (prodType.includes('mtg') || prodType.includes('magic') || lowerTags.some(t => t.includes('mtg') || t.includes('magic'))) {
        game = 'mtg';
        badgeLabel = 'MTG';
    } else if (prodType.includes('riftbound')) {
        game = 'riftbound';
    } else if (lowerTags.includes('brand_basketball')) {
        game = 'sports';
        badgeLabel = 'Basketball';
    } else if (prodType === 'sport single' || prodType === 'sport sealed') {
        game = 'sports';
    } else if (lowerTags.some(t => t.includes('pokemon') || t.includes('pokémon') || t.includes('brand_pokemon'))) {
        game = 'pokemon';
    } else if (lowerTags.some(t => t.includes('onepiece') || t.includes('one-piece') || t.includes('one piece') || t.includes('brand_one piece'))) {
        game = 'onepiece';
    } else if (lowerTags.some(t => t.includes('sports') || t.includes('sport') || t.includes('brand_sports'))) {
        game = 'sports';
    } else if (lowerTags.some(t => t.includes('riftbound') || t.includes('rift') || t.includes('brand_riftbound'))) {
        game = 'riftbound';
    }

    let set = product.vendor ? product.vendor.trim() : '';
    if (!set) {
        const setTag = tags.find(t => t.toLowerCase().startsWith('set:'));
        if (setTag) {
            set = setTag.substring(4).trim();
        }
    }

    let psa = 'Raw';
    const psaTag = tags.find(t => t.toLowerCase().startsWith('psa:'));
    if (psaTag) {
        const parsedPsa = psaTag.split(':')[1].trim();
        psa = parsedPsa.toLowerCase() === 'raw' ? 'Raw' : parsedPsa;
    } else {
        // Match "psa 10", "psa10", "psa_10" (Shopify Category_Value tag format)
        const psaMatchTag = lowerTags.find(t => /^psa[\s_]*(10|[1-9])$/.test(t));
        if (psaMatchTag) {
            const match = psaMatchTag.match(/^psa[\s_]*(10|[1-9])$/);
            if (match) psa = match[1];
        }
    }

    let bgsGrade = null;
    const bgsTag = tags.find(t => t.toLowerCase().startsWith('bgs:'));
    if (bgsTag) {
        const parsedBgs = bgsTag.split(':')[1].trim();
        if (parsedBgs.toLowerCase() !== 'raw') {
            bgsGrade = parsedBgs;
        }
    } else {
        const bgsMatchTag = lowerTags.find(t => /^bgs[\s_]*(11|10|[1-9](\.5)?)$/.test(t));
        if (bgsMatchTag) {
            const match = bgsMatchTag.match(/^bgs[\s_]*(11|10|[1-9](\.5)?)$/);
            if (match) bgsGrade = match[1];
        }
    }

    const tagGrade = parseImageSlabGrade(tags, 'tag');
    const cgcGrade = parseImageSlabGrade(tags, 'cgc');

    let mintGrade = null;
    const mintTag = tags.find(t => t.toLowerCase().startsWith('mint:'));
    if (mintTag) {
        const parsedMint = mintTag.split(':')[1].trim();
        const mintNum = parseFloat(parsedMint);
        if (mintNum >= 1 && mintNum <= 10 && (Number.isInteger(mintNum) || mintNum % 1 === 0.5)) {
            mintGrade = mintNum.toString();
        }
    } else {
        const mintMatchTag = lowerTags.find(t => /^mint\s*(10|[1-9](\.5)?)$/.test(t));
        if (mintMatchTag) {
            const match = mintMatchTag.match(/^mint\s*(10|[1-9](\.5)?)$/);
            if (match) mintGrade = match[1];
        }
    }

    // Owner tag (debug: Dom, Victor)
    const OWNER_TAGS = ['dom', 'victor'];
    let owner = null;
    const ownerTag = lowerTags.find(t => OWNER_TAGS.includes(t));
    if (ownerTag) {
        owner = ownerTag.charAt(0).toUpperCase() + ownerTag.slice(1);
    }

    let finish = 'Non-Foil';
    const combinedText = `${product.name || ''} ${tags.join(' ')}`.toLowerCase();
    if (combinedText.includes('holo') || combinedText.includes('holographic') || combinedText.includes('holofoil')) {
        finish = 'Holo';
    } else if (combinedText.includes('foil') && !combinedText.includes('non-foil') && !combinedText.includes('nonfoil')) {
        finish = 'Foil';
    } else if (lowerTags.some(t => t.includes('normal') || t.includes('non-foil') || t.includes('nonfoil'))) {
        finish = 'Non-Foil';
    }

    let format = 'Raw';
    if (prodType === 'yugioh sealed' || prodType.includes('sealed') || lowerTags.includes('type_sealed')) {
        format = 'Sealed';
        psa = 'Sealed';
    } else if (psa !== 'Raw' || bgsGrade || tagGrade || cgcGrade || mintGrade) {
        format = 'Slabs';
    }

    let cardPrice = product.basePrice || 0;
    let cardStock = 0;
    const isAnyGraded = (psa !== "Raw" && psa !== "Sealed") || !!bgsGrade || !!tagGrade || !!cgcGrade || !!mintGrade;

    if (product.variants && product.variants.length > 0) {
        // Calculate total available stock across all variants
        cardStock = product.variants.reduce((sum, v) => sum + (v.stock !== undefined ? Math.max(0, v.stock) : 0), 0);

        if (!isAnyGraded) {
            const validVariants = product.variants.filter(v => getVariantCondition(v) !== null);
            if (validVariants.length > 0) {
                const inStockVariants = validVariants.filter(v => (v.stock !== undefined ? v.stock : 0) > 0);
                if (inStockVariants.length > 0) {
                    cardPrice = Math.max(...inStockVariants.map(v => v.price || 0));
                } else {
                    validVariants.sort((a, b) => CONDITION_HIERARCHY.indexOf(getVariantCondition(a)) - CONDITION_HIERARCHY.indexOf(getVariantCondition(b)));
                    cardPrice = validVariants[0].price || cardPrice;
                }
            } else {
                const inStockVariants = product.variants.filter(v => (v.stock !== undefined ? v.stock : 0) > 0);
                if (inStockVariants.length > 0) {
                    cardPrice = Math.max(...inStockVariants.map(v => v.price || 0));
                }
            }
        }
    } else {
        cardStock = product.stock !== undefined ? product.stock : 5;
    }

    return {
        id: product.id,
        name: product.name,
        set: set,
        vendor: (product.vendor || '').trim(),
        game: game,
        badgeLabel: badgeLabel || (game === 'onepiece' ? 'ONE PIECE' : (game === 'yugioh' ? 'Yu-Gi-Oh!' : game.toUpperCase())),
        basePrice: cardPrice,
        stock: cardStock,
        image: product.image || getFallbackImage(game),
        variants: (product.variants || []).map(v => {
            let vImg = v.image;
            if (!vImg && v.featured_image) {
                vImg = typeof v.featured_image === 'string' ? v.featured_image : v.featured_image.src;
            }
            return {
                ...v,
                image: vImg || null
            };
        }),
        options: product.options || [],
        psa: psa,
        bgsGrade: bgsGrade,
        tagGrade: tagGrade,
        cgcGrade: cgcGrade,
        mintGrade: mintGrade,
        finish: finish,
        format: format,
        owner: owner,
        productType: product.product_type || product.productType || product.type || "",
        desc: product.desc || product.description || "",
        tags: tags
    };
}

/**
 * Maps a simple admin product object from localStorage to the format expected by the storefront catalog.
 */
function mapAdminProductToTcgItem(p) {
    const prodType = (p.productType || p.product_type || p.type || '').toLowerCase().trim();
    let game = p.game || 'pokemon';
    if (prodType === 'yugioh single' || prodType === 'yugioh sealed' || prodType.includes('yugioh') || prodType.includes('yu-gi-oh')) {
        game = 'yugioh';
    } else if (prodType.includes('mtg') || prodType.includes('magic')) {
        game = 'mtg';
    } else if (prodType.includes('riftbound')) {
        game = 'riftbound';
    }
    let psa = 'Raw';
    let bgsGrade = null;
    let tagGrade = null;
    let cgcGrade = null;
    let mintGrade = null;
    let format = 'Raw';
    let condition = p.condition || '';

    // Parse condition to determine slab type and grade
    const condLower = condition.toLowerCase();
    if (condLower.includes('bgs')) {
        const match = condLower.match(/bgs\s*(11|10|[1-9](\.5)?)/);
        bgsGrade = match ? match[1] : '10';
        format = 'Slabs';
    } else if (condLower.includes('psa')) {
        const match = condLower.match(/psa\s*(\d+(\.5)?)/);
        psa = match ? match[1] : '10';
        format = 'Slabs';
    } else if (condLower.includes('tag')) {
        const match = condLower.match(/tag\s*(\d+(\.5)?)/);
        tagGrade = parseImageSlabGrade([condition], 'tag') || (match ? match[1] : '10');
        format = 'Slabs';
    } else if (condLower.includes('cgc')) {
        const match = condLower.match(/cgc\s*(\d+(\.5)?)/);
        cgcGrade = parseImageSlabGrade([condition], 'cgc') || (match ? match[1] : '10');
        format = 'Slabs';
    } else if (condLower.includes('mint') && !condLower.includes('near mint')) {
        const match = condLower.match(/mint\s*(\d+(\.5)?)/);
        mintGrade = match ? match[1] : '10';
        format = 'Slabs';
    }

    if (prodType === 'yugioh sealed' || prodType.includes('sealed') || condLower.includes('sealed') || (p.set && p.set.toLowerCase().includes('sealed'))) {
        format = 'Sealed';
        psa = 'Sealed';
    }

    let finish = 'Non-Foil';
    const nameLower = p.name.toLowerCase();
    if (nameLower.includes('holo') || nameLower.includes('holographic') || nameLower.includes('holofoil')) {
        finish = 'Holo';
    } else if (nameLower.includes('foil') && !nameLower.includes('non-foil') && !nameLower.includes('nonfoil')) {
        finish = 'Foil';
    }

    // Set options and variants
    let options = [];
    let variants = [];
    if (format === 'Raw') {
        options = ['Condition'];
        variants = [
            { id: p.id * 1000 + 1, title: p.condition || 'Near Mint', price: p.price, stock: p.stock, option1: p.condition || 'Near Mint' }
        ];
    } else {
        options = ['Title'];
        variants = [
            { id: p.id * 1000 + 1, title: p.condition || 'Slab', price: p.price, stock: p.stock, option1: p.condition || 'Slab' }
        ];
    }

    return {
        id: p.id,
        name: p.name,
        set: p.set || '',
        vendor: (p.vendor || '').trim(),
        game: game,
        badgeLabel: game === 'onepiece' ? 'ONE PIECE' : (game === 'yugioh' ? 'Yu-Gi-Oh!' : game.toUpperCase()),
        condition: condition,
        basePrice: p.price,
        stock: p.stock,
        image: p.image || getFallbackImage(game),
        variants: variants,
        options: options,
        psa: psa,
        bgsGrade: bgsGrade,
        tagGrade: tagGrade,
        cgcGrade: cgcGrade,
        mintGrade: mintGrade,
        finish: finish,
        format: format,
        owner: null,
        productType: p.productType || p.product_type || p.type || "",
        desc: p.description || p.desc || `${p.name} - ${p.condition || ''} (${p.set || ''})`,
        tags: p.tags || (psa !== 'Raw' ? ["psa: " + psa] : [])
    };
}

window.addEventListener('storage', (e) => {
    if (e.key === 'ss_admin_products' && e.newValue) {
        try {
            const savedProducts = JSON.parse(e.newValue);
            const tcgItems = [];
            savedProducts.forEach(p => {
                const mapped = mapAdminProductToTcgItem(p);
                tcgItems.push(mapped);
            });
            if (tcgItems.length > 0) {
                tcgInventory = tcgItems;
                if (typeof renderTCGGrid === 'function') {
                    renderTCGGrid(false);
                }
            }
        } catch (err) {
            console.error("Failed to sync storage change:", err);
        }
    }
});

const INITIAL_TCG_INVENTORY = [];

let CAFE_INVENTORY = [];

// --- SHOP STATE ---
let tcgInventory = [...INITIAL_TCG_INVENTORY];
let allShopifyProducts = [];
let cart = [];
let activeGame = "all";
let activeCafeCat = "all";
let currentCatalogPage = 1;

// --- STATE PERSISTENCE HELPERS ---
function saveCart() {
    try {
        localStorage.setItem("spacesocial_cart", JSON.stringify(cart));
    } catch (e) {
        console.error("Failed to save cart to localStorage", e);
    }
}

function loadCart() {
    try {
        const saved = localStorage.getItem("spacesocial_cart");
        if (saved) {
            cart = JSON.parse(saved);
        } else {
            cart = [];
        }
    } catch (e) {
        console.error("Failed to load cart from localStorage", e);
        cart = [];
    }
}

function highlightActiveLink() {
    const currentPath = window.location.pathname;
    const currentHref = window.location.href;

    document.querySelectorAll(".nav-link").forEach(link => {
        const href = link.getAttribute("href");
        if (!href) return;
        // Check if path or href matches
        if (currentHref.endsWith(href) || currentPath.endsWith(href) || currentHref.includes(href) || currentPath.includes(href)) {
            link.classList.add("active");
        } else {
            link.classList.remove("active");
        }
    });
}

// Cache raw product data, scoped to the storefront language and currency.
const catalogCacheKey = `ss_catalog_v1:${document.documentElement.lang}:${window.Shopify?.currency?.active || 'default'}`;
let catalogRefreshPending = false;
let catalogLastAttempt = 0;

// --- INITIALIZATION ---
function runInit() {
    // Fade in page by hiding the preloader overlay
    const transitionOverlay = document.getElementById("page-transition-overlay");
    if (transitionOverlay) {
        requestAnimationFrame(() => {
            transitionOverlay.classList.add("fade-out-active");
        });
    }

    initApp();
    setupEventListeners();
    setupMainProductCart();
    initLandingPage();
    highlightActiveLink();
    setupPageTransitions();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
} else {
    runInit();
}

window.addEventListener("pageshow", (event) => {
    // Reset landing page split panels and transition overlays if restored from cache/back button
    const overlay = document.getElementById("split-landing-overlay");
    if (overlay) {
        overlay.classList.remove('transitioning-out');
        document.body.style.overflow = 'hidden';
        const gifSplash = document.getElementById('landing-gif-splash');
        if (gifSplash) {
            gifSplash.classList.remove('visible');
            gifSplash.classList.add('hidden');
        }
    }
    const transitionOverlay = document.getElementById("page-transition-overlay");
    if (transitionOverlay) {
        transitionOverlay.classList.remove("fade-out-active");
        requestAnimationFrame(() => {
            transitionOverlay.classList.add("fade-out-active");
        });
    }
});

function initApp() {
    // Admin mode turns off on page refresh (unless on admin.html page)
    if (window.location.pathname.includes("admin")) {
        window.isPruneModeActive = true;
        document.body.classList.add("admin-mode-active");
    } else {
        window.isPruneModeActive = false;
        document.body.classList.remove("admin-mode-active");
    }

    if (localStorage.getItem("ss_inventory_check_mode_active") === "true") {
        window.isInventoryCheckModeActive = true;
        const checkToggle = document.getElementById("admin-check-mode-toggle");
        if (checkToggle) checkToggle.checked = true;
    }

    if (localStorage.getItem("ss_hide_fully_checked_active") === "true") {
        window.isHideFullyCheckedActive = true;
        const hideToggle = document.getElementById("admin-hide-fully-checked-toggle");
        if (hideToggle) hideToggle.checked = true;
    }

    // Always reload inventory audit data from cookie/localStorage upon startup
    loadInventoryAuditCookie();

    // Load cart first
    loadCart();

    // Sync customer account button state in header if logged in locally
    const isLoggedIn = localStorage.getItem("spacesocial_customer_logged_in") === "true";
    const accountBtn = document.querySelector(".account-btn-header");
    if (accountBtn) {
        if (isLoggedIn) {
            accountBtn.setAttribute("href", "#");
            accountBtn.setAttribute("title", "Your Account (Click to Log Out)");
            accountBtn.setAttribute("aria-label", "Your Account (Click to Log Out)");
            accountBtn.innerHTML = '<i class="fa-solid fa-user"></i>';
            accountBtn.onclick = (e) => {
                e.preventDefault();
                localStorage.removeItem("spacesocial_customer_logged_in");
                localStorage.removeItem("spacesocial_customer_email");
                showToast("Logged Out", "You have signed out of your account.");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            };
        }
    }

    // 1. Sync from localStorage (Admin Panel changes) or Live Shopify Products HTML element
    let loadedFromAdmin = false;
    const isLiveShopify = window.location.protocol !== 'file:' &&
        !window.location.hostname.includes('localhost') &&
        !window.location.hostname.includes('127.0.0.1');

    if (!isLiveShopify) {
        const savedAdminProductsStr = localStorage.getItem('ss_admin_products');
        if (savedAdminProductsStr) {
            try {
                const savedProducts = JSON.parse(savedAdminProductsStr);
                const tcgItems = [];
                savedProducts.forEach(p => {
                    const mapped = mapAdminProductToTcgItem(p);
                    tcgItems.push(mapped);
                });
                if (tcgItems.length > 0) {
                    tcgInventory = tcgItems;
                    loadedFromAdmin = true;
                    console.log(`Loaded ${tcgItems.length} TCG Singles from localStorage (Admin Panel).`);
                }
            } catch (e) {
                console.error("Failed to parse localStorage products. Falling back to shopify data.", e);
            }
        }
    }

    if (!loadedFromAdmin) {
        const shopifyProductsDataEl = document.getElementById("shopify-products-data");
        if (shopifyProductsDataEl) {
            try {
                const liveProducts = safeParseShopifyProductsJson(shopifyProductsDataEl.textContent);
                const cachedProducts = readCatalogCache();
                // Show the complete cached catalog first; replace it only after a full refresh.
                applyCatalogProducts(cachedProducts || liveProducts);
                if (isLiveShopify) {
                    requestAnimationFrame(() => refreshCatalogProducts());
                    const refreshIfVisible = () => {
                        if (!document.hidden && Date.now() - catalogLastAttempt > 60000) refreshCatalogProducts();
                    };
                    window.addEventListener('focus', refreshIfVisible);
                    document.addEventListener('visibilitychange', refreshIfVisible);
                    setInterval(refreshIfVisible, 5 * 60 * 1000);
                } else {
                    // Preview data is already complete and must never fetch production inventory.
                    applyCatalogProducts(liveProducts);
                    writeCatalogCache(liveProducts);
                }
            } catch (e) {
                console.error("Failed to parse live Shopify catalog. Using defaults.", e);
                if (typeof window.reportStoreError === 'function') {
                    window.reportStoreError({
                        message: "Live Shopify JSON Parse Error: " + e.message,
                        stack: e.stack
                    });
                }
            }
        }
    }

    renderTCGGrid();
    enhanceStaticPreorderCards();
    updateCartTotals();
}

function enhanceStaticPreorderCards() {
    // Release cards render their stock-aware status in Liquid.
    document.querySelectorAll('.tcg-card-item:not(.release-card)').forEach(item => {
        const cardId = parseInt(item.getAttribute('data-card-id'), 10);
        if (!isNaN(cardId)) {
            const card = tcgInventory.find(c => c.id === cardId);
            if (card && card.tags) {
                const isPreorder = card.tags.includes('pre-order');
                const isUnavailable = card.tags.includes('unavailable');
                const imgContainer = item.querySelector('.card-img-container');

                if (imgContainer) {
                    if (isUnavailable) {
                        // Remove preorder badge if present
                        const existingPreorder = imgContainer.querySelector('.preorder-badge');
                        if (existingPreorder) existingPreorder.remove();

                        // Add unavailable badge
                        if (!imgContainer.querySelector('.unavailable-badge')) {
                            const badge = document.createElement('span');
                            badge.className = 'unavailable-badge';
                            badge.innerHTML = `<i class="fa-solid fa-ban"></i> Unavailable`;
                            imgContainer.appendChild(badge);
                        }

                        item.classList.add('unavailable-card');

                        // Hide price
                        const priceEl = item.querySelector('.card-price');
                        if (priceEl) {
                            priceEl.style.display = 'none';
                        }
                    } else {
                        // Remove unavailable badge
                        const existingUnavailable = imgContainer.querySelector('.unavailable-badge');
                        if (existingUnavailable) existingUnavailable.remove();
                        item.classList.remove('unavailable-card');

                        // Restore price display if it was hidden
                        const priceEl = item.querySelector('.card-price');
                        if (priceEl) {
                            priceEl.style.display = '';
                        }

                        if (isPreorder) {
                            if (!imgContainer.querySelector('.preorder-badge')) {
                                const badge = document.createElement('span');
                                badge.className = 'preorder-badge';
                                badge.innerHTML = `<i class="fa-solid fa-clock"></i> Pre-Order`;
                                imgContainer.appendChild(badge);
                            }
                        } else {
                            // Remove preorder badge
                            const existingPreorder = imgContainer.querySelector('.preorder-badge');
                            if (existingPreorder) existingPreorder.remove();
                        }
                    }
                }
            }
        }
    });
}

/**
 * Updates the retrieval status display next to the catalog results count.
 * Displays a loading spinner while products are being retrieved via AJAX,
 * and a completion badge once all products are fully loaded.
 */
window.updateRetrievalStatusDisplay = function (isRetrieving, msg, failed = false) {
    const el = document.getElementById("catalog-retrieval-status");
    if (!el) return;

    el.setAttribute('role', 'status');
    if (failed) {
        el.className = "retrieval-status-badge";
        el.style.display = "inline-flex";
        el.innerHTML = '<i class="fa-solid fa-circle-exclamation"></i> <span>Refresh unavailable</span>';
    } else if (isRetrieving) {
        el.className = "retrieval-status-badge fetching";
        el.style.display = "inline-flex";
        el.innerHTML = `<i class="fa-solid fa-spinner fa-spin text-gold"></i> <span>${msg || "Retrieving products..."}</span>`;
    } else {
        el.className = "retrieval-status-badge complete";
        el.style.display = "inline-flex";
        el.innerHTML = `<i class="fa-solid fa-circle-check text-green"></i> <span>100% — All products loaded</span>`;
    }
};

/**
 * Recursively fetches subsequent pages from the /collections/in-stock-catalog collection
 * to bypass pagination caps (e.g. 250 products limit).
 */
function readCatalogCache() {
    try {
        const cached = JSON.parse(localStorage.getItem(catalogCacheKey));
        if (cached?.version !== 1 || !Number.isFinite(cached.savedAt) || Date.now() - cached.savedAt > 24 * 60 * 60 * 1000 ||
            !Array.isArray(cached.products) || !cached.products.every(p => p && p.id && Array.isArray(p.variants))) return null;
        return cached.products;
    } catch (_) { return null; }
}
function writeCatalogCache(products) {
    try {
        localStorage.setItem(catalogCacheKey, JSON.stringify({ version: 1, savedAt: Date.now(), products }));
    } catch (_) { /* Storage may be disabled or full; the live catalog still works. */ }
}
function applyCatalogProducts(products) {
    allShopifyProducts = products;
    tcgInventory = products.map(parseShopifyProduct).filter(Boolean);
}
async function refreshCatalogProducts() {
    if (catalogRefreshPending) return;
    catalogRefreshPending = true;
    catalogLastAttempt = Date.now();
    window.updateRetrievalStatusDisplay?.(true, 'Loading products: 0%');
    try {
        const products = new Map();
        let page = 1;
        while (true) {
            const root = window.Shopify?.routes?.root || '/';
            const url = new URL(`${root}collections/in-stock-catalog`, location.origin);
            url.searchParams.set('page', page);
            const response = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(20000) });
            if (!response.ok) throw new Error(`Catalog refresh failed (${response.status})`);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = doc.getElementById('shopify-products-data');
            if (!data || !data.textContent.trim()) throw new Error('Missing catalog data');
            const batch = safeParseShopifyProductsJson(data.textContent);
            if (!Array.isArray(batch) || !batch.every(p => p && p.id && Array.isArray(p.variants))) throw new Error('Invalid catalog data');
            let added = 0;
            batch.forEach(product => {
                if (!products.has(product.id)) added++;
                products.set(product.id, product);
            });
            const total = Number(data.getAttribute?.('data-total-products'));
            const progress = Number.isFinite(total) && total > 0
                ? `Loading products: ${Math.min(99, Math.floor(products.size / total * 100))}%`
                : `Loading products: ${products.size} loaded`;
            window.updateRetrievalStatusDisplay?.(true, progress);
            if (batch.length < 250) break;
            if (!added || page >= 500) throw new Error('Catalog pagination did not advance');
            page++;
        }
        const fresh = [...products.values()];
        const changed = JSON.stringify(fresh) !== JSON.stringify(allShopifyProducts);
        applyCatalogProducts(fresh);
        writeCatalogCache(fresh);
        if (changed) {
            renderTCGGrid(false);
            enhanceStaticPreorderCards();
            updateCartTotals();
            const modal = document.getElementById('card-modal');
            if (modal && !modal.classList.contains('hidden') && modal.dataset.cardId) {
                const cardId = Number(modal.dataset.cardId);
                const selected = document.getElementById('modal-condition-select')?.value;
                if (tcgInventory.some(card => card.id === cardId)) {
                    openCardModal(cardId);
                    const select = document.getElementById('modal-condition-select');
                    if (select && [...select.options].some(option => option.value === selected)) {
                        select.value = selected;
                        select.dispatchEvent(new Event('change'));
                    }
                } else {
                    closeCardModal();
                }
            }
        }
        document.dispatchEvent(new CustomEvent('catalog:refreshed'));
        window.updateRetrievalStatusDisplay?.(false);
    } catch (error) {
        // Keep the last complete snapshot on offline, partial, or malformed responses.
        console.warn('Keeping cached catalog; background refresh unavailable.', error);
        window.updateRetrievalStatusDisplay?.(false, null, true);
    } finally {
        catalogRefreshPending = false;
    }
}

// Initialize split landing page overlay
function initLandingPage() {
    const overlay = document.getElementById("split-landing-overlay");
    if (!overlay) return;

    // Lock body scroll while overlay is active on homepage
    document.body.style.overflow = 'hidden';

    // Prevent scroll restoration jumping on reload
    window.scrollTo(0, 0);

    const enterCafeBtn = document.getElementById("enter-cafe-btn");
    const enterTcgBtn = document.getElementById("enter-tcg-btn");
    const cafePanel = document.getElementById("panel-left");
    const tcgPanel = document.getElementById("panel-right");

    const cafeUrl = (enterCafeBtn && enterCafeBtn.getAttribute("href")) || "cafe.html";
    const tcgUrl = (enterTcgBtn && enterTcgBtn.getAttribute("href")) || "tcg.html";

    if (enterCafeBtn) {
        enterCafeBtn.addEventListener("click", (e) => {
            e.preventDefault();
            exitLanding(cafeUrl);
        });
    }

    if (enterTcgBtn) {
        enterTcgBtn.addEventListener("click", (e) => {
            e.preventDefault();
            exitLanding(tcgUrl);
        });
    }

    // Clicking anywhere on the panel triggers the same navigation
    if (cafePanel) {
        cafePanel.addEventListener("click", (e) => {
            if (e.target.closest("a")) return; // Let button handle its own click
            exitLanding(cafeUrl);
        });
    }

    if (tcgPanel) {
        tcgPanel.addEventListener("click", (e) => {
            if (e.target.closest("a")) return;
            exitLanding(tcgUrl);
        });
    }

    function exitLanding(targetUrl) {
        document.body.style.overflow = '';

        // Step 1: Prepare the GIF splash BEHIND the panels (visible but under them)
        const gifSplash = document.getElementById('landing-gif-splash');
        if (gifSplash) {
            gifSplash.classList.remove('hidden');
            gifSplash.classList.add('visible');
        }

        // Step 2: Immediately start sliding panels apart to reveal the GIF
        requestAnimationFrame(() => {
            overlay.classList.add('transitioning-out');
        });

        // Step 3: After panels have fully slid away (1s), hold on GIF briefly then navigate
        setTimeout(() => {
            window.location.href = targetUrl;
        }, 1800);
    }
}

// --- RENDER FUNCTIONS ---

// Render TCG Catalog Grid with sorting and filtering
function getCatalogSetVendors(cards, game) {
    if (game === 'all') return [];
    return [...new Set(cards.filter(card =>
        (card.game || 'pokemon') === game &&
        (card.stock === undefined || card.stock > 0) &&
        !window.hiddenCardIds?.has(card._uniqueId) && !window.hiddenCardIds?.has(card.id)
    ).map(card => (card.vendor || '').trim()).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b));
}

function syncCatalogSetFilter() {
    const group = document.getElementById('fpg-set');
    if (!group) return;
    const vendors = getCatalogSetVendors(tcgInventory, activeGame);
    const signature = JSON.stringify([activeGame, vendors]);
    if (group.dataset.signature === signature) return;
    const sameGame = group.dataset.game === activeGame;
    const selected = sameGame
        ? new Set(Array.from(group.querySelectorAll('.set-filter:checked'), input => input.value))
        : new Set();
    group.dataset.signature = signature;
    group.dataset.game = activeGame;
    group.style.display = activeGame === 'all' ? 'none' : '';
    if (!sameGame) {
        group.classList.remove('active');
        document.getElementById('catalog-set-search').value = '';
    }
    const options = document.getElementById('catalog-set-options');
    options.innerHTML = vendors.length ? vendors.map(vendor =>
        `<label class="filter-checkbox"><input type="checkbox" class="set-filter" value="${escapeHtml(vendor)}"${selected.has(vendor) ? ' checked' : ''}><span>${escapeHtml(vendor)}</span></label>`
    ).join('') : '<p>No sets available.</p>';
    filterCatalogSetOptions();
    group.classList.toggle('has-selection', !!group.querySelector('.set-filter:checked'));
    const count = document.querySelectorAll('#catalog-filter-options input[type="checkbox"]:checked').length;
    const countLabel = document.querySelector('.catalog-filter-selection-count');
    if (countLabel) countLabel.textContent = count ? ` (${count})` : '';
}

function filterCatalogSetOptions() {
    const search = document.getElementById('catalog-set-search');
    if (!search) return;
    const term = search.value.trim().toLowerCase();
    const labels = document.querySelectorAll('#catalog-set-options label');
    let matches = 0;
    labels.forEach(label => {
        const visible = label.textContent.toLowerCase().includes(term);
        label.style.display = visible ? '' : 'none';
        if (visible) matches++;
    });
    document.getElementById('catalog-set-empty').hidden = !labels.length || matches > 0;
}

function renderTCGGrid(resetPage = true) {
    if (resetPage !== false) {
        currentCatalogPage = 1;
    }
    const grid = document.getElementById("cards-grid");
    if (!grid) return;

    if (window.isPruneModeActive) {
        grid.classList.add("admin-grid-active");
    } else {
        grid.classList.remove("admin-grid-active");
    }

    // Ensure every item has a unique ID for visual weeding/pruning
    if (tcgInventory) {
        tcgInventory.forEach(card => {
            if (!card._uniqueId) {
                card._uniqueId = ++globalUniqueCardCounter;
            }
        });
    }

    try {
        syncCatalogSetFilter();
        // Get filter inputs
        const filterSearch = document.getElementById("singles-filter-search") ? document.getElementById("singles-filter-search").value.toLowerCase() : "";
        const globalSearch = document.getElementById("global-search") ? document.getElementById("global-search").value.toLowerCase() : "";
        const activeSearch = filterSearch || globalSearch;

        const checkedConditions = Array.from(document.querySelectorAll(".condition-filter:checked")).map(el => el.value);
        const checkedPSAs = Array.from(document.querySelectorAll(".psa-filter:checked")).map(el => el.value);
        const checkedBGSs = Array.from(document.querySelectorAll(".bgs-filter:checked")).map(el => el.value);
        const checkedTAGs = Array.from(document.querySelectorAll(".tag-filter:checked")).map(el => el.value);
        const checkedCGCs = Array.from(document.querySelectorAll(".cgc-filter:checked")).map(el => el.value);
        const checkedMints = Array.from(document.querySelectorAll(".mint-filter:checked")).map(el => el.value);
        const checkedFinishes = Array.from(document.querySelectorAll(".finish-filter:checked")).map(el => el.value);
        const checkedFormats = Array.from(document.querySelectorAll(".format-filter:checked")).map(el => el.value);
        const checkedSets = Array.from(document.querySelectorAll('.set-filter:checked')).map(el => el.value);
        const inStockOnly = true;
        const activeOwner = "all";

        grid.innerHTML = "";

        // Filter
        let filteredCards = tcgInventory.filter(card => {
            if (window.hiddenCardIds && (window.hiddenCardIds.has(card._uniqueId) || (card.id && window.hiddenCardIds.has(card.id)))) return false;
            // Null safety guards for the card object
            const cardName = card.name || "Unnamed Card";
            const cardSet = card.set || "";
            const cardGame = card.game || "pokemon";

            const cardPSA = card.psa || "Raw";
            const cardFinish = card.finish || "Non-Foil";
            const cardFormat = card.format || "Raw";
            const cardStock = card.stock !== undefined ? card.stock : 5;

            // Game check
            if (activeGame !== "all" && cardGame !== activeGame) return false;
            if (activeGame !== 'all' && checkedSets.length && !checkedSets.includes((card.vendor || '').trim())) return false;

            // Pokémon Language Subfilter Check (Only active when filtered to Pokémon category)
            if (activeGame === "pokemon") {
                const checkedLanguages = Array.from(document.querySelectorAll(".language-filter:checked")).map(el => el.value);
                const targetPokemonLang = window.activePokemonLang || "all";
                const cardLang = typeof window.getPokemonLanguage === "function" ? window.getPokemonLanguage(card) : "english";
                if (checkedLanguages.length > 0) {
                    if (!checkedLanguages.includes(cardLang)) return false;
                } else if (targetPokemonLang !== "all") {
                    if (cardLang !== targetPokemonLang) return false;
                }
            }

            // Search text check (supports multi-word searches like "Prismatic Elite")
            if (activeSearch) {
                const searchTerms = activeSearch.trim().toLowerCase().split(/\s+/).filter(Boolean);
                if (searchTerms.length > 0) {
                    const cardTags = Array.isArray(card.tags) ? card.tags.join(" ") : (card.tags || "");
                    const cardDesc = card.description || card.body_html || "";
                    const cardSku = card.sku || card.number || "";
                    const cardVendor = card.vendor || "";
                    const cardRarity = card.rarity || "";
                    const searchableText = `${cardName} ${cardSet} ${cardGame} ${cardFormat} ${cardVendor} ${cardRarity} ${cardFinish} ${cardTags} ${cardDesc} ${cardSku}`.toLowerCase();
                    const matchesAllTerms = searchTerms.every(term => searchableText.includes(term));
                    if (!matchesAllTerms) return false;
                }
            }

            // Sealed visibility rule: if any filter is checked, only show sealed products if 'Sealed' is checked
            const sealedCheckbox = document.querySelector(".format-filter[value='Sealed']");
            if (sealedCheckbox) {
                const anyFilterChecked = !!document.querySelector(".condition-filter:checked, .psa-filter:checked, .bgs-filter:checked, .tag-filter:checked, .cgc-filter:checked, .mint-filter:checked, .finish-filter:checked, .format-filter:checked");
                if (cardFormat === "Sealed" && anyFilterChecked && !sealedCheckbox.checked) return false;
            }

            // Format check
            if (checkedFormats.length && !checkedFormats.includes(cardFormat)) return false;

            // Condition check
            if (checkedConditions.length) {
                const isPsaGraded = card.psa && card.psa !== "Raw" && card.psa !== "Sealed";
                const isBgsGraded = !!card.bgsGrade;
                const isAnyGradedCard = isPsaGraded || isBgsGraded || !!card.tagGrade || !!card.cgcGrade || !!card.mintGrade;
                if (isAnyGradedCard || !card.variants || card.variants.length === 0) {
                    return false;
                }
                const hasMatchingVariant = card.variants.some(v => {
                    const cond = getVariantCondition(v);
                    const matchesCond = checkedConditions.includes(cond);
                    if (!matchesCond) return false;
                    if (inStockOnly && (v.stock !== undefined ? v.stock : 0) <= 0) return false;
                    return true;
                });
                if (!hasMatchingVariant) return false;
            }

            // Grading filter checks (OR logic across companies)
            const hasAnyGradingFilter = checkedPSAs.length > 0 || checkedBGSs.length > 0 || checkedTAGs.length > 0 || checkedCGCs.length > 0 || checkedMints.length > 0;

            if (hasAnyGradingFilter) {
                let matchGrading = false;

                // PSA check
                if (checkedPSAs.length && cardPSA && cardPSA !== "Raw" && cardPSA !== "Sealed") {
                    if (checkedPSAs.includes(cardPSA)) {
                        matchGrading = true;
                    } else if (checkedPSAs.includes("1-7")) {
                        const psaNum = parseInt(cardPSA, 10);
                        if (!isNaN(psaNum) && psaNum >= 1 && psaNum <= 7) {
                            matchGrading = true;
                        }
                    }
                }

                // BGS check
                if (!matchGrading && checkedBGSs.length && card.bgsGrade) {
                    if (checkedBGSs.includes(card.bgsGrade)) {
                        matchGrading = true;
                    } else if (checkedBGSs.includes("1-7")) {
                        const bgsNum = parseFloat(card.bgsGrade);
                        if (!isNaN(bgsNum) && bgsNum >= 1 && bgsNum <= 7) {
                            matchGrading = true;
                        }
                    }
                }

                // TAG check
                if (!matchGrading && checkedTAGs.length && card.tagGrade) {
                    if (checkedTAGs.includes(card.tagGrade)) {
                        matchGrading = true;
                    } else if (checkedTAGs.includes("1-7")) {
                        const tagNum = parseFloat(card.tagGrade);
                        if (!isNaN(tagNum) && tagNum >= 1 && tagNum <= 7) {
                            matchGrading = true;
                        }
                    }
                }

                // CGC check
                if (!matchGrading && checkedCGCs.length && card.cgcGrade) {
                    if (checkedCGCs.includes(card.cgcGrade)) {
                        matchGrading = true;
                    } else if (checkedCGCs.includes("1-7")) {
                        const cgcNum = parseFloat(card.cgcGrade);
                        if (!isNaN(cgcNum) && cgcNum >= 1 && cgcNum <= 7) {
                            matchGrading = true;
                        }
                    }
                }

                // Mint check
                if (!matchGrading && checkedMints.length && card.mintGrade) {
                    if (checkedMints.includes(card.mintGrade)) {
                        matchGrading = true;
                    } else if (checkedMints.includes("1-7")) {
                        const mintNum = parseFloat(card.mintGrade);
                        if (!isNaN(mintNum) && mintNum >= 1 && mintNum <= 7) {
                            matchGrading = true;
                        }
                    }
                }

                if (!matchGrading) return false;
            }

            // Finish check
            if (checkedFinishes.length && !checkedFinishes.includes(cardFinish)) return false;

            // Stock check
            if (inStockOnly && cardStock <= 0) return false;

            // Debug: Owner tag check
            if (activeOwner !== "all") {
                const cardOwner = card.owner || null;
                if (activeOwner === "untagged") {
                    if (cardOwner !== null) return false;
                } else {
                    if (!cardOwner || cardOwner !== activeOwner) return false;
                }
            }

            // Admin Mode: Hide fully checked products if toggle is ON
            if (window.isPruneModeActive && window.isHideFullyCheckedActive && typeof window.isProductFullyChecked === "function" && window.isProductFullyChecked(card)) {
                return false;
            }

            return true;
        });

        // Sort
        const sortVal = document.getElementById("catalog-sort") ? document.getElementById("catalog-sort").value : "default";
        if (sortVal === "price-asc") {
            filteredCards.sort((a, b) => (a.basePrice || 0) - (b.basePrice || 0));
        } else if (sortVal === "price-desc") {
            filteredCards.sort((a, b) => (b.basePrice || 0) - (a.basePrice || 0));
        } else if (sortVal === "name-asc") {
            filteredCards.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
        } else if (sortVal === "name-desc") {
            filteredCards.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
        } else if (sortVal === "cant-find-first") {
            filteredCards.sort((a, b) => {
                const recA = window.getInventoryAuditRecord(a.id || a._uniqueId);
                const recB = window.getInventoryAuditRecord(b.id || b._uniqueId);
                const cantA = recA && recA.status === "cant_find" ? 1 : 0;
                const cantB = recB && recB.status === "cant_find" ? 1 : 0;
                if (cantA !== cantB) return cantB - cantA;
                const timeA = recA && recA.timestamp ? new Date(recA.timestamp).getTime() : 0;
                const timeB = recB && recB.timestamp ? new Date(recB.timestamp).getTime() : 0;
                return timeA - timeB;
            });
        } else if (sortVal === "audit-asc") {
            // Timestamp: Never Checked (time = 0) / Oldest first
            filteredCards.sort((a, b) => {
                const tsA = window.getInventoryAuditTimestamp(a.id || a._uniqueId);
                const tsB = window.getInventoryAuditTimestamp(b.id || b._uniqueId);
                const timeA = tsA ? new Date(tsA).getTime() : 0;
                const timeB = tsB ? new Date(tsB).getTime() : 0;
                if (timeA !== timeB) return timeA - timeB;
                return (a.name || "").localeCompare(b.name || "");
            });
        } else if (sortVal === "audit-desc") {
            // Timestamp: Recently checked first
            filteredCards.sort((a, b) => {
                const tsA = window.getInventoryAuditTimestamp(a.id || a._uniqueId);
                const tsB = window.getInventoryAuditTimestamp(b.id || b._uniqueId);
                const timeA = tsA ? new Date(tsA).getTime() : 0;
                const timeB = tsB ? new Date(tsB).getTime() : 0;
                if (timeA !== timeB) return timeB - timeA;
                return (a.name || "").localeCompare(b.name || "");
            });
        }

        // Update results count label
        const resultsCountEl = document.getElementById("catalog-results-count");
        if (resultsCountEl) {
            resultsCountEl.textContent = `${filteredCards.length} card${filteredCards.length === 1 ? '' : 's'} found`;
        }

        // Calculate debug values
        let rawStockTotal = 0;
        let gradedStockTotal = 0;
        let sealedStockTotal = 0;

        filteredCards.forEach(card => {
            const format = card.format || "Raw";
            const unitPrice = card.basePrice || 0;
            const stock = card.stock !== undefined ? card.stock : 0;

            let cardStockVal = 0;

            if (card.variants && card.variants.length > 0) {
                card.variants.forEach(v => {
                    cardStockVal += (v.price || 0) * (v.stock !== undefined ? v.stock : 0);
                });
            } else {
                cardStockVal = unitPrice * stock;
            }

            if (format === "Raw") {
                rawStockTotal += cardStockVal;
            } else if (format === "Slabs") {
                gradedStockTotal += cardStockVal;
            } else if (format === "Sealed") {
                sealedStockTotal += cardStockVal;
            }
        });

        const combinedStockTotal = rawStockTotal + gradedStockTotal + sealedStockTotal;

        // Update DOM elements
        const rawValEl = document.getElementById("debug-raw-value");
        const gradedValEl = document.getElementById("debug-graded-value");
        const sealedValEl = document.getElementById("debug-sealed-value");
        const totalValEl = document.getElementById("debug-total-value");

        if (rawValEl) {
            rawValEl.textContent = `$${rawStockTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        if (gradedValEl) {
            gradedValEl.textContent = `$${gradedStockTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        if (sealedValEl) {
            sealedValEl.textContent = `$${sealedStockTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        if (totalValEl) {
            totalValEl.textContent = `$${combinedStockTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }

        const paginationContainer = document.getElementById("catalog-pagination");

        if (filteredCards.length === 0) {
            grid.innerHTML = `
                <div class="no-results" style="grid-column: 1 / -1; text-align: center; padding: 40px; color: var(--clr-muted);">
                    <i class="fa-solid fa-face-frown text-gold" style="font-size: 2.5rem; margin-bottom: 12px; display: block;"></i>
                    <h4>No matching cards.</h4>
                    <p>Try adjusting your search query or checkbox filters.</p>
                </div>
            `;
            if (paginationContainer) paginationContainer.innerHTML = "";
            return;
        }

        currentCatalogPage = Math.min(currentCatalogPage, Math.max(1, Math.ceil(filteredCards.length / 100)));

        // Render pagination controls (each page shows 100 products)
        renderPagination(filteredCards.length, currentCatalogPage, 100, (newPage) => {
            currentCatalogPage = newPage;
            renderTCGGrid(false); // Do not reset page when switching pages
            const section = document.getElementById("tcg-catalog");
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        });

        // Slice products to only display 100 at once for the current page
        const cardsToRender = filteredCards.slice((currentCatalogPage - 1) * 100, currentCatalogPage * 100);

        cardsToRender.forEach(card => {
            const item = document.createElement("div");
            item.className = "tcg-card-item";
            if (window.isPruneModeActive) {
                item.classList.add("compact-admin-card");
            }
            item.setAttribute("data-card-id", card.id);

            // Null safety parameters for rendering
            const cardName = card.name || "Unnamed Card";
            const escapedCardName = escapeHtml(cardName);
            const cardSet = card.set || "";
            const cardGame = card.game || "pokemon";

            const cardPSA = card.psa || "Raw";
            const cardFinish = card.finish || "Non-Foil";
            const cardStock = card.stock !== undefined ? card.stock : 5;
            const cardPrice = card.basePrice || 0;
            const cardImage = card.image || getFallbackImage(cardGame);


            const isOutOfStock = cardStock <= 0;

            const defaultCond = isOutOfStock ? "HP" : "NM";

            const isPsaGraded = cardPSA && cardPSA !== "Raw" && cardPSA !== "Sealed";
            const psaBadgeHtml = isPsaGraded ? `<span class="psa-badge grade-${cardPSA}">PSA ${cardPSA}</span>` : "";

            const cardBgsGrade = card.bgsGrade || null;
            const bgsBadgeHtml = cardBgsGrade ? `<span class="bgs-badge bgs-grade-${cardBgsGrade}">BGS ${cardBgsGrade}</span>` : "";
            const isBgsGraded = !!cardBgsGrade;

            const cardTagGrade = card.tagGrade || null;
            const tagBadgeHtml = cardTagGrade ? `<span class="tag-badge tag-grade-${cardTagGrade}">TAG ${cardTagGrade}</span>` : "";

            const cardCgcGrade = card.cgcGrade || null;
            const cgcBadgeHtml = cardCgcGrade ? `<span class="cgc-badge cgc-grade-${cardCgcGrade}">CGC ${cardCgcGrade}</span>` : "";

            const cardMintGrade = card.mintGrade || null;
            const mintBadgeHtml = cardMintGrade ? `<span class="mint-badge mint-grade-${cardMintGrade}">MINT ${cardMintGrade}</span>` : "";

            const isAnyGraded = isPsaGraded || isBgsGraded || !!cardTagGrade || !!cardCgcGrade || !!cardMintGrade;

            const hasFinish = cardFinish && cardFinish !== "Non-Foil";
            const finishBadgeHtml = hasFinish ? `<span class="finish-badge ${cardFinish.toLowerCase()}">${cardFinish}</span>` : "";

            const isSealed = card.format === "Sealed";
            const sealedBadgeHtml = isSealed ? `<span class="finish-badge sealed" style="background-color: var(--clr-royal-purple); color: var(--clr-white); font-weight: 600;">Sealed</span>` : "";

            const gameLabel = card.badgeLabel || (cardGame === "onepiece" ? "ONE PIECE" : cardGame.toUpperCase());

            // Graded cards: show price for debugging as requested
            let priceHtml;
            const isInStoreOnlyCard = isInStoreOnly(card);
            const isPriceError = cardPrice <= 0;
            if (isPriceError) {
                priceHtml = `<div class="card-pricing-row"><span class="card-price price-error" id="price-${card.id}" style="color: #ef4444; font-weight: bold;">Price Error</span></div>`;
            } else {
                priceHtml = `<div class="card-pricing-row"><span class="card-price" id="price-${card.id}">$${cardPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>`;
            }

            const isPreorder = card.tags && card.tags.includes('pre-order');
            const isUnavailable = card.tags && card.tags.includes('unavailable');
            const preorderBadgeHtml = isPreorder ? `<span class="preorder-badge"><i class="fa-solid fa-clock"></i> Pre-Order</span>` : "";
            const unavailableBadgeHtml = isUnavailable ? `<span class="unavailable-badge"><i class="fa-solid fa-ban"></i> Unavailable</span>` : "";

            // Hide price entirely for unavailable products
            if (isUnavailable || isInStoreOnlyCard) {
                priceHtml = ``;
            }

            let footerHtml;
            if (window.isPruneModeActive) {
                let conditionsList = '';
                const CONDITION_SHORT = {
                    'Near Mint': 'NM',
                    'Lightly Played': 'LP',
                    'Moderately Played': 'MP',
                    'Heavily Played': 'HP',
                    'Damaged': 'DMG'
                };

                if (card.variants && card.variants.length > 0) {
                    conditionsList = card.variants.map(v => {
                        const canonical = normalizeCondition(v.option1);
                        const condLabel = canonical ? (CONDITION_SHORT[canonical] || canonical) : (v.option1 || 'Default');
                        const vStock = v.stock !== undefined ? v.stock : 0;
                        const vPrice = v.price || 0;
                        const priceStr = vPrice <= 0 ? "N/A" : `$${vPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        const stockClass = vStock > 0 ? 'admin-qty-positive' : 'admin-qty-zero';
                        const isDisabled = vStock <= 0;
                        const disabledClass = isDisabled ? 'disabled' : '';

                        const auditRecordItem = window.getInventoryAuditRecord ? window.getInventoryAuditRecord(card.id || card._uniqueId) : null;
                        const condRecord = auditRecordItem && auditRecordItem.conditions && auditRecordItem.conditions[condLabel] ? auditRecordItem.conditions[condLabel] : null;
                        const checkedCnt = condRecord ? (condRecord.checkedCount || 0) : 0;
                        const checkedBadgeHtml = checkedCnt > 0 
                            ? `<span class="cond-checked-badge" title="Checked ${checkedCnt} times"><i class="fa-solid fa-check"></i> ${checkedCnt}${vStock > 0 ? '/' + vStock : ''}<button class="cond-minus-btn" data-card-id="${escapeHtml(card.id || card._uniqueId)}" data-cond-label="${escapeHtml(condLabel)}" title="Subtract 1 check">-</button></span>`
                            : ``;

                        return `
                            <div class="admin-cond-item ${disabledClass} ${checkedCnt > 0 ? 'audited-cond-item' : ''}" data-card-id="${escapeHtml(card.id)}" data-cond-label="${escapeHtml(condLabel)}" data-variant-id="${escapeHtml(v.id)}" ${isDisabled ? 'data-disabled="true"' : ''}>
                                <span class="cond-label">${escapeHtml(condLabel)}:</span>
                                <span><span class="${stockClass}">${vStock}</span> @ <span class="admin-vibrant-price">${priceStr}</span></span>
                                ${checkedBadgeHtml}
                            </div>`;
                    }).join('');
                } else {
                    const condLabel = isBgsGraded ? `BGS ${cardBgsGrade}` : (isPsaGraded ? `PSA ${cardPSA}` : (card.condition || 'Raw'));
                    const vStock = card.stock !== undefined ? card.stock : 0;
                    const vPrice = card.basePrice || 0;
                    const priceStr = vPrice <= 0 ? "N/A" : `$${vPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                    const stockClass = vStock > 0 ? 'admin-qty-positive' : 'admin-qty-zero';
                    const isDisabled = vStock <= 0;
                    const disabledClass = isDisabled ? 'disabled' : '';

                    const auditRecordItem = window.getInventoryAuditRecord ? window.getInventoryAuditRecord(card.id || card._uniqueId) : null;
                    const condRecord = auditRecordItem && auditRecordItem.conditions && auditRecordItem.conditions[condLabel] ? auditRecordItem.conditions[condLabel] : null;
                    const checkedCnt = condRecord ? (condRecord.checkedCount || 0) : 0;
                    const checkedBadgeHtml = checkedCnt > 0 
                        ? `<span class="cond-checked-badge" title="Checked ${checkedCnt} times"><i class="fa-solid fa-check"></i> ${checkedCnt}${vStock > 0 ? '/' + vStock : ''}<button class="cond-minus-btn" data-card-id="${escapeHtml(card.id || card._uniqueId)}" data-cond-label="${escapeHtml(condLabel)}" title="Subtract 1 check">-</button></span>`
                        : ``;

                    conditionsList = `
                        <div class="admin-cond-item ${disabledClass} ${checkedCnt > 0 ? 'audited-cond-item' : ''}" data-card-id="${escapeHtml(card.id)}" data-cond-label="${escapeHtml(condLabel)}" ${isDisabled ? 'data-disabled="true"' : ''}>
                            <span class="cond-label">${escapeHtml(condLabel)}:</span>
                            <span><span class="${stockClass}">${vStock}</span> @ <span class="admin-vibrant-price">${priceStr}</span></span>
                            ${checkedBadgeHtml}
                        </div>`;
                }

                footerHtml = `
                    <div class="card-item-footer compact-admin-footer" style="padding-top: 8px;">
                        <div class="admin-conditions-list">
                            ${conditionsList}
                        </div>
                    </div>`;
            } else if (isInStoreOnlyCard || (isAnyGraded && cardPrice >= 100)) {
                footerHtml = `
                    <div class="card-item-footer">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                            <span class="stock-text">
                                <i class="fa-solid fa-warehouse ${isOutOfStock ? 'text-red' : 'text-green'}"></i>
                                ${isOutOfStock ? 'Out of Stock' : `${cardStock} in stock`}
                            </span>
                        </div>
                        <div class="in-store-only-label">
                            <i class="fa-solid fa-store"></i> Available in Store
                        </div>
                    </div>`;
            } else {
                const buttonDisabled = isOutOfStock || isPriceError || isUnavailable;
                const buttonText = isUnavailable
                    ? '<i class="fa-solid fa-ban"></i> Unavailable'
                    : (isPriceError
                        ? '<i class="fa-solid fa-triangle-exclamation"></i> Price Error'
                        : (isOutOfStock
                            ? (isPreorder ? 'Pre-Order Closed' : 'Out of Stock')
                            : (isPreorder
                                ? '<i class="fa-solid fa-calendar-plus"></i> Pre-Order'
                                : '<i class="fa-solid fa-plus"></i> Add to Cart')));

                const stockText = isUnavailable
                    ? 'Currently Unavailable'
                    : (isPriceError
                        ? 'Unavailable'
                        : (isOutOfStock
                            ? (isPreorder ? 'Pre-Orders Closed' : 'Out of Stock')
                            : (isPreorder
                                ? `${cardStock} available`
                                : `${cardStock} in stock`)));
                const stockIcon = (isOutOfStock || isUnavailable) ? 'text-red' : 'text-green';
                const stockHtml = isUnavailable
                    ? `<i class="fa-solid fa-ban text-red"></i> ${stockText}`
                    : (isPreorder
                        ? `<i class="fa-solid fa-clock" style="color: ${isOutOfStock ? 'var(--clr-red)' : '#fbbf24'};"></i> ${stockText}`
                        : `<i class="fa-solid fa-warehouse ${stockIcon}"></i> ${stockText}`);

                const getOptName = (opt) => (typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : '')).toLowerCase();
                const hasVersionCategory = card.options && card.options.some(opt => getOptName(opt) === "version" || getOptName(opt).includes("version"));

                let versionSelectHtml = "";
                let selectedVariantId = null;

                if (hasVersionCategory && !isAnyGraded && card.variants && card.variants.length > 0) {
                    let defaultIdx = card.variants.findIndex(v => (v.stock !== undefined ? v.stock : 0) > 0);
                    if (defaultIdx === -1) defaultIdx = 0;
                    selectedVariantId = card.variants[defaultIdx] ? card.variants[defaultIdx].id : null;

                    const optionsHtml = card.variants.map((v, idx) => {
                        const optVal = v.option1 || v.title || `Version ${idx + 1}`;
                        const priceVal = (v.price || 0) <= 0 ? "Price Error" : `$${v.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        const vStock = v.stock !== undefined ? v.stock : 0;
                        const stockText = vStock <= 0 ? " (Out of Stock)" : ` (${vStock} in stock)`;
                        const isSel = idx === defaultIdx ? 'selected' : '';
                        return `<option value="${v.id}" ${isSel} ${vStock <= 0 ? 'disabled' : ''}>${optVal} - ${priceVal}${stockText}</option>`;
                    }).join('');

                    versionSelectHtml = `
                        <div class="version-select-wrapper" style="margin-bottom: 10px; width: 100%;">
                            <label for="card-version-select-${card.id}" class="version-select-label" style="font-size: 0.75rem; font-weight: 700; color: var(--clr-gold); display: flex; align-items: center; gap: 4px; margin-bottom: 4px;">
                                <i class="fa-solid fa-layer-group text-gold"></i> Select Version:
                            </label>
                            <select class="card-version-select form-select-sm" 
                                    id="card-version-select-${card.id}" 
                                    data-card-id="${card.id}" 
                                    onclick="event.stopPropagation();"
                                    style="width: 100%; padding: 6px 10px; border-radius: 8px; background: rgba(255,255,255,0.08); color: var(--clr-text); border: 1px solid rgba(212,175,55,0.4); font-size: 0.8rem; font-weight: 600; cursor: pointer;">
                                 ${optionsHtml}
                            </select>
                        </div>
                    `;
                }

                footerHtml = `
                    <div class="card-item-footer">
                        ${versionSelectHtml}
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                            <span class="stock-text" id="stock-${card.id}">
                                ${stockHtml}
                            </span>
                        </div>
                        <button class="btn btn-primary btn-full btn-sm add-cart-card-btn" 
                                data-card-id="${card.id}" 
                                ${selectedVariantId ? `data-selected-variant-id="${selectedVariantId}"` : ''}
                                ${buttonDisabled ? 'disabled' : ''}
                                ${isUnavailable ? 'style="background-color: #6b7280; border-color: #6b7280; opacity: 0.8;"' : (isPriceError ? 'style="background-color: #ef4444; border-color: #ef4444;"' : '')}>
                            ${buttonText}
                        </button>
                    </div>`;
            }

            let imageHtml;
            const unavailableCardClass = isUnavailable ? ' unavailable-card' : '';
            if (isUnavailable) item.classList.add('unavailable-card');
            const imageSlab = getImageSlab(card);
            if (imageSlab) {
                imageHtml = `
                    <div class="psa-slab-wrapper ${imageSlab.company}-slab-wrapper">
                        <img class="psa-slab-bg" src="${imageSlab.image}" alt="${imageSlab.label} Slab">
                        <img class="psa-card-img ratio-slab-card" src="${cardImage}" alt="${escapedCardName}">
                    </div>
                `;
            } else if (isBgsGraded) {
                const bgsSlabImg = getBgsSlabImage(cardBgsGrade);
                imageHtml = `
                    <div class="psa-slab-wrapper bgs-slab-wrapper">
                        <img class="psa-slab-bg bgs-slab-bg" src="${bgsSlabImg}" alt="BGS ${cardBgsGrade} Slab">
                        <img class="psa-card-img ratio-slab-card" src="${cardImage}" alt="${escapedCardName}">
                    </div>
                `;
            } else if (isPsaGraded) {
                let slabGrade = parseInt(cardPSA, 10);
                if (isNaN(slabGrade) || slabGrade > 10) slabGrade = 10;
                if (slabGrade < 1) slabGrade = 1;
                const psaSlabImg = (window.themeAssets && window.themeAssets.psaSlabs && window.themeAssets.psaSlabs[slabGrade]) ? window.themeAssets.psaSlabs[slabGrade] : `assets/PSA${slabGrade}.webp`;
                imageHtml = `
                    <div class="psa-slab-wrapper">
                        <img class="psa-slab-bg" src="${psaSlabImg}" alt="PSA ${cardPSA} Slab">
                        <img class="psa-card-img ratio-slab-card" src="${cardImage}" alt="${escapedCardName}">
                    </div>
                `;
            } else {
                imageHtml = `<img src="${cardImage}" alt="${escapedCardName}">`;
            }

            const overlayBadgeHtml = isUnavailable ? unavailableBadgeHtml : preorderBadgeHtml;
            const auditRecord = window.getInventoryAuditRecord ? window.getInventoryAuditRecord(card.id || card._uniqueId) : null;
            const auditTimestamp = auditRecord ? auditRecord.timestamp : null;
            const isCantFind = auditRecord && auditRecord.status === "cant_find";
            const isChecked = !!auditTimestamp;
            const auditTimeShort = window.formatAuditTimeShort ? window.formatAuditTimeShort(auditTimestamp) : (isChecked ? "Checked" : "Unchecked");
            const auditTimeFull = window.formatAuditTime ? window.formatAuditTime(auditTimestamp) : "";

            let conditionCountsSummary = '';
            if (auditRecord && auditRecord.conditions && Object.keys(auditRecord.conditions).length > 0) {
                const parts = [];
                for (const [k, v] of Object.entries(auditRecord.conditions)) {
                    if (v && v.checkedCount > 0) {
                        parts.push(`${k}: ${v.checkedCount}`);
                    }
                }
                if (parts.length > 0) {
                    conditionCountsSummary = ` (${parts.join(', ')})`;
                }
            }

            const pruneBtnHtml = window.isPruneModeActive ? `
                <button class="prune-remove-btn" data-unique-id="${escapeHtml(card._uniqueId || card.id)}" title="Hide from catalog">
                    <i class="fa-solid fa-eye-slash"></i>
                </button>
            ` : "";

            const cantFindBtnHtml = window.isPruneModeActive ? `
                <button class="admin-cant-find-btn ${isCantFind ? 'active' : ''}" 
                        data-card-id="${escapeHtml(card.id || card._uniqueId)}" 
                        title="${isCantFind ? 'Currently flagged as Can\'t Find' : 'Mark item as Can\'t Find in store inventory'}">
                    <i class="fa-solid fa-ban"></i>
                    <span>Can't Find</span>
                </button>
            ` : "";

            const auditStatusHtml = window.isPruneModeActive ? `
                <div class="card-audit-status ${isCantFind ? 'cant-find' : (isChecked ? 'checked' : 'unchecked')}">
                    <i class="fa-solid ${isCantFind ? 'fa-triangle-exclamation' : (isChecked ? 'fa-circle-check' : 'fa-circle-exclamation')}"></i>
                    <span>${isCantFind ? 'Can\'t Find (' + auditTimeShort + ')' : (isChecked ? 'Checked ' + auditTimeShort + conditionCountsSummary : 'Never Checked')}</span>
                </div>
            ` : "";

            if (isCantFind) {
                item.classList.add("cant-find-card-item");
            } else {
                item.classList.remove("cant-find-card-item");
            }

            item.innerHTML = `
                <div class="card-img-container">
                    ${cantFindBtnHtml}
                    ${pruneBtnHtml}
                    ${imageHtml}
                    <div class="slab-badges-container">
                        ${psaBadgeHtml}
                        ${bgsBadgeHtml}
                        ${tagBadgeHtml}
                        ${cgcBadgeHtml}
                        ${mintBadgeHtml}
                    </div>
                    ${finishBadgeHtml}
                    ${sealedBadgeHtml}
                    ${overlayBadgeHtml}
                </div>
                <div class="card-details">
                    ${cardSet ? `<span class="card-set">${escapeHtml(cardSet)}</span>` : ""}
                    <h3 class="card-name" title="${escapedCardName}" data-copy-name="${escapedCardName}">${escapedCardName}</h3>
                    ${auditStatusHtml}
                    ${priceHtml}
                    ${footerHtml}
                </div>
            `;

            grid.appendChild(item);
        });

        renderInventoryOverchecks();

        // Bind directly so Safari recognizes each condition pill as a tap target.
        grid.querySelectorAll(".admin-cond-item").forEach(conditionItem => {
            conditionItem.setAttribute("role", "button");
            conditionItem.setAttribute("tabindex", "0");
            conditionItem.setAttribute("aria-disabled", conditionItem.getAttribute("data-disabled") === "true" ? "true" : "false");
            conditionItem.addEventListener("click", handleAdminConditionClick);
            conditionItem.addEventListener("keydown", (e) => {
                if (e.target === conditionItem && (e.key === "Enter" || e.key === " ")) {
                    handleAdminConditionClick(e);
                }
            });
        });

        // Bind Version Select Dropdown & Add to Cart button listeners
        grid.querySelectorAll(".card-version-select").forEach(selectEl => {
            selectEl.addEventListener("change", (e) => {
                e.stopPropagation();
                const cardId = parseInt(selectEl.getAttribute("data-card-id"), 10);
                const variantId = parseInt(selectEl.value, 10);
                const card = tcgInventory.find(c => c.id === cardId);
                if (!card || !card.variants) return;

                const variant = card.variants.find(v => v.id === variantId);
                if (!variant) return;

                const cardItem = selectEl.closest(".tcg-card-item");
                if (!cardItem) return;

                // Update price display
                const priceEl = cardItem.querySelector(`#price-${cardId}`);
                if (priceEl) {
                    if ((variant.price || 0) <= 0) {
                        priceEl.className = "card-price price-error";
                        priceEl.style.color = "#ef4444";
                        priceEl.textContent = "Price Error";
                    } else {
                        priceEl.className = "card-price";
                        priceEl.style.color = "";
                        priceEl.textContent = `$${variant.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                    }
                }

                // Update stock display
                const stockEl = cardItem.querySelector(`#stock-${cardId}`);
                const vStock = variant.stock !== undefined ? variant.stock : 0;
                const isOutOfStock = vStock <= 0;
                const isPreorder = card.tags && card.tags.includes('pre-order');
                const addBtn = cardItem.querySelector(`.add-cart-card-btn[data-card-id="${cardId}"]`);

                if (stockEl) {
                    const stockIcon = isOutOfStock ? 'text-red' : 'text-green';
                    const stockText = isOutOfStock 
                        ? (isPreorder ? 'Pre-Orders Closed' : 'Out of Stock') 
                        : (isPreorder ? `${vStock} available` : `${vStock} in stock`);
                    stockEl.innerHTML = isPreorder
                        ? `<i class="fa-solid fa-clock" style="color: ${isOutOfStock ? 'var(--clr-red)' : '#fbbf24'};"></i> ${stockText}`
                        : `<i class="fa-solid fa-warehouse ${stockIcon}"></i> ${stockText}`;
                }

                if (addBtn) {
                    addBtn.disabled = isOutOfStock;
                    addBtn.setAttribute("data-selected-variant-id", variantId);
                    if (isOutOfStock) {
                        addBtn.textContent = isPreorder ? "Pre-Order Closed" : "Out of Stock";
                    } else {
                        addBtn.innerHTML = isPreorder ? '<i class="fa-solid fa-calendar-plus"></i> Pre-Order' : '<i class="fa-solid fa-plus"></i> Add to Cart';
                    }
                }

                // Update image if variant has custom photo
                const imgEl = cardItem.querySelector(".card-img-container img");
                if (imgEl && variant.image) {
                    imgEl.src = variant.image;
                }
            });
        });

        grid.querySelectorAll(".add-cart-card-btn").forEach(btn => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                const cardId = parseInt(btn.getAttribute("data-card-id"), 10);
                const selectedVariantId = btn.getAttribute("data-selected-variant-id") ? parseInt(btn.getAttribute("data-selected-variant-id"), 10) : null;
                addToCart(cardId, "tcg", selectedVariantId);
            });
        });

        if (typeof window.calculateInventoryValues === "function") {
            window.calculateInventoryValues();
        }
    } catch (e) {
        console.error("Error rendering TCG grid:", e);
        if (typeof window.reportStoreError === 'function') {
            window.reportStoreError({
                message: "renderTCGGrid Error: " + e.message,
                stack: e.stack
            });
        }
    }
}

/**
 * Renders the pagination controls for the TCG catalog grid.
 */
function renderPagination(totalItems, currentPage, itemsPerPage, onPageChange) {
    const container = document.getElementById("catalog-pagination");
    if (!container) return;

    container.innerHTML = "";
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (totalPages <= 1) return; // No pagination needed if 1 page or empty

    // Prev Button
    const prevBtn = document.createElement("button");
    prevBtn.className = "pagination-btn";
    prevBtn.innerHTML = `<i class="fa-solid fa-chevron-left"></i> Prev`;
    prevBtn.disabled = currentPage === 1;
    prevBtn.addEventListener("click", () => onPageChange(currentPage - 1));
    container.appendChild(prevBtn);

    // Smart page numbers range
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
        const firstPageBtn = document.createElement("button");
        firstPageBtn.className = "pagination-btn";
        firstPageBtn.textContent = "1";
        firstPageBtn.addEventListener("click", () => onPageChange(1));
        container.appendChild(firstPageBtn);

        if (startPage > 2) {
            const ellipsis = document.createElement("span");
            ellipsis.className = "pagination-ellipsis";
            ellipsis.textContent = "...";
            container.appendChild(ellipsis);
        }
    }

    for (let p = startPage; p <= endPage; p++) {
        const pageBtn = document.createElement("button");
        pageBtn.className = `pagination-btn ${p === currentPage ? 'active' : ''}`;
        pageBtn.textContent = p;
        pageBtn.addEventListener("click", () => onPageChange(p));
        container.appendChild(pageBtn);
    }

    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            const ellipsis = document.createElement("span");
            ellipsis.className = "pagination-ellipsis";
            ellipsis.textContent = "...";
            container.appendChild(ellipsis);
        }

        const lastPageBtn = document.createElement("button");
        lastPageBtn.className = "pagination-btn";
        lastPageBtn.textContent = totalPages;
        lastPageBtn.addEventListener("click", () => onPageChange(totalPages));
        container.appendChild(lastPageBtn);
    }

    // Next Button
    const nextBtn = document.createElement("button");
    nextBtn.className = "pagination-btn";
    nextBtn.innerHTML = `Next <i class="fa-solid fa-chevron-right"></i>`;
    nextBtn.disabled = currentPage === totalPages;
    nextBtn.addEventListener("click", () => onPageChange(currentPage + 1));
    container.appendChild(nextBtn);
}

// Fullscreen Card Image Lightbox Overlay
function openCardLightbox(sourceElement) {
    if (!sourceElement) return;
    let lightbox = document.getElementById("image-lightbox-modal");
    if (!lightbox) {
        lightbox = document.createElement("div");
        lightbox.id = "image-lightbox-modal";
        lightbox.className = "image-lightbox-overlay hidden";
        lightbox.innerHTML = `
            <div class="lightbox-content">
                <button id="close-lightbox-btn" class="lightbox-close-btn" aria-label="Close full view"><i class="fa-solid fa-xmark"></i></button>
                <div id="lightbox-image-container" class="lightbox-image-container"></div>
                <span class="lightbox-hint"><i class="fa-solid fa-magnifying-glass-minus"></i> Click anywhere to close</span>
            </div>
        `;
        document.body.appendChild(lightbox);

        lightbox.addEventListener("click", function (evt) {
            lightbox.classList.add("hidden");
        });

        const closeBtn = lightbox.querySelector("#close-lightbox-btn");
        if (closeBtn) {
            closeBtn.addEventListener("click", function (evt) {
                evt.stopPropagation();
                lightbox.classList.add("hidden");
            });
        }

        document.addEventListener("keydown", function (evt) {
            if (evt.key === "Escape" && lightbox && !lightbox.classList.contains("hidden")) {
                lightbox.classList.add("hidden");
            }
        });
    }

    const container = lightbox.querySelector("#lightbox-image-container");
    if (container) {
        const slabWrapper = sourceElement.closest(".psa-slab-wrapper") || (sourceElement.classList.contains("psa-slab-wrapper") ? sourceElement : null);
        if (slabWrapper) {
            container.innerHTML = slabWrapper.outerHTML;
        } else if (sourceElement.tagName && sourceElement.tagName.toLowerCase() === "img") {
            container.innerHTML = `<img src="${sourceElement.src}" alt="${sourceElement.alt || 'Card Full View'}">`;
        } else {
            const img = sourceElement.querySelector("img");
            if (img) {
                container.innerHTML = `<img src="${img.src}" alt="${img.alt || 'Card Full View'}">`;
            } else {
                container.innerHTML = sourceElement.outerHTML;
            }
        }
    }

    lightbox.classList.remove("hidden");
}

// Open Card Details Modal
function openCardModal(cardId) {
    const card = tcgInventory.find(c => c.id === cardId);
    if (!card) return;

    const modal = document.getElementById("card-modal");
    const img = document.getElementById("modal-card-image");
    const name = document.getElementById("modal-card-name");
    const set = document.getElementById("modal-card-set");
    const badge = document.getElementById("modal-card-game-badge");
    const price = document.getElementById("modal-card-price");
    const stock = document.getElementById("modal-card-stock");
    const addBtn = document.getElementById("modal-add-to-cart-btn");

    const condContainer = document.getElementById("modal-condition-selector-container");
    const condSelect = document.getElementById("modal-condition-select");

    if (!modal) return;
    modal.dataset.cardId = String(cardId);

    const isPsaGraded = card.psa && card.psa !== "Raw" && card.psa !== "Sealed";
    const isBgsGraded = !!card.bgsGrade;
    const imagePanel = document.querySelector(".card-modal-image-panel");
    if (imagePanel) {
        const imageSlab = getImageSlab(card);
        if (imageSlab) {
            imagePanel.innerHTML = `
                <div class="psa-slab-wrapper ${imageSlab.company}-slab-wrapper" style="height: 100%; aspect-ratio: 574/975; display: flex; justify-content: center; align-items: center; margin: 0 auto; cursor: zoom-in;">
                    <img class="psa-slab-bg" src="${imageSlab.image}" alt="${imageSlab.label} Slab">
                    <img class="psa-card-img ratio-slab-card" src="${card.image}" alt="${card.name}">
                </div>
            `;
        } else if (isBgsGraded) {
            const bgsSlabImg = getBgsSlabImage(card.bgsGrade);
            imagePanel.innerHTML = `
                <div class="psa-slab-wrapper bgs-slab-wrapper" style="height: 100%; aspect-ratio: 574/975; display: flex; justify-content: center; align-items: center; margin: 0 auto; cursor: zoom-in;">
                    <img class="psa-slab-bg bgs-slab-bg" src="${bgsSlabImg}" alt="BGS ${card.bgsGrade} Slab" style="width: 100% !important; height: 100% !important; object-fit: contain !important;">
                    <img class="psa-card-img ratio-slab-card" src="${card.image}" alt="${card.name}">
                </div>
            `;
        } else if (isPsaGraded) {
            let slabGrade = parseInt(card.psa, 10);
            if (isNaN(slabGrade) || slabGrade > 10) slabGrade = 10;
            if (slabGrade < 1) slabGrade = 1;
            const psaSlabImg = (window.themeAssets && window.themeAssets.psaSlabs && window.themeAssets.psaSlabs[slabGrade]) ? window.themeAssets.psaSlabs[slabGrade] : `assets/PSA${slabGrade}.webp`;
            imagePanel.innerHTML = `
                <div class="psa-slab-wrapper" style="height: 100%; aspect-ratio: 574/975; display: flex; justify-content: center; align-items: center; margin: 0 auto; cursor: zoom-in;">
                    <img class="psa-slab-bg" src="${psaSlabImg}" alt="PSA ${card.psa} Slab" style="width: 100% !important; height: 100% !important; object-fit: contain !important;">
                    <img class="psa-card-img ratio-slab-card" src="${card.image}" alt="${card.name}">
                </div>
            `;
        } else {
            const isPreorder = card.tags && card.tags.includes('pre-order');
            const badgeHtml = isPreorder ? `<span class="preorder-badge" style="left: 12px; top: 12px;"><i class="fa-solid fa-clock"></i> Pre-Order</span>` : "";
            imagePanel.innerHTML = `
                <div style="position: relative; display: block; text-align: center; width: 100%; cursor: zoom-in;">
                    <img id="modal-card-image" src="${card.image}" alt="${card.name}" style="cursor: zoom-in;">
                    ${badgeHtml}
                </div>
            `;
        }

        // Add Click to Zoom / Fullscreen Lightbox logic
        imagePanel.onclick = function (e) {
            const zoomTarget = e.target.closest('#modal-card-image') || e.target.closest('.psa-slab-wrapper') || e.target.closest('.card-modal-image-panel img') || e.target.closest('.card-modal-image-panel');
            if (zoomTarget) {
                openCardLightbox(zoomTarget);
            }
        };
    }

    name.textContent = card.name;

    if (card.set) {
        set.textContent = card.set;
        set.style.display = "";
    } else {
        set.style.display = "none";
    }

    badge.textContent = card.badgeLabel || (card.game === "onepiece" ? "ONE PIECE" : card.game.toUpperCase());
    badge.className = `game-badge ${card.game}`;

    // Reset shared modal state when switching between products.
    price.style.display = "";
    addBtn.classList.remove("btn-in-store");
    addBtn.style.backgroundColor = "";
    addBtn.style.borderColor = "";
    condSelect.onchange = null;
    condSelect.innerHTML = "";

    // Handle Variant / Condition Selector
    const getOptionName = (opt) => (typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : '')).toLowerCase();
    const hasConditionOption = card.options && card.options.some(opt => getOptionName(opt) === "condition");
    const hasVersionOption = card.options && card.options.some(opt => getOptionName(opt) === "version");

    // isPsaGraded is evaluated above
    const isTagGraded = !!card.tagGrade;
    const isCgcGraded = !!card.cgcGrade;
    const isMintGraded = !!card.mintGrade;
    const isAnyGraded = isPsaGraded || isBgsGraded || isTagGraded || isCgcGraded || isMintGraded;

    const selectorLabel = document.querySelector("#modal-condition-selector-container label");

    // Graded cards: if $100 or over, show "Available in Store", disable add-to-cart. Graded cards under $100 can be bought online.
    if (isInStoreOnly(card)) {
        condContainer.style.display = "none";
        price.innerHTML = '<span class="in-store-only-label">Available in store</span>';
        stock.textContent = "";
        addBtn.disabled = true;
        addBtn.innerHTML = '<i class="fa-solid fa-store"></i> Available in store';
        addBtn.classList.add("btn-in-store");
        addBtn.onclick = null;
    } else if (isAnyGraded && card.basePrice >= 100) {
        condContainer.style.display = "none";
        if (card.basePrice <= 0) {
            price.innerHTML = `<span style="color: #ef4444; font-weight: bold;">Price Error</span>`;
        } else {
            price.textContent = `$${card.basePrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        const grCardStock = card.stock !== undefined ? card.stock : 0;
        const grOutOfStock = grCardStock <= 0;
        stock.innerHTML = `<i class="fa-solid fa-warehouse ${grOutOfStock ? 'text-red' : 'text-green'}"></i> ${grOutOfStock ? 'Out of Stock' : `${grCardStock} in stock`}`;
        addBtn.disabled = true;
        addBtn.innerHTML = `<i class="fa-solid fa-store"></i> Available in Store Only`;
        addBtn.classList.add("btn-in-store");
        addBtn.onclick = null;
    } else if (!isAnyGraded && hasVersionOption && card.variants && card.variants.length > 0) {
        if (selectorLabel) selectorLabel.textContent = "Version:";
        condContainer.style.display = "block";

        const versionVariants = card.variants;
        let defaultSelectedIndex = versionVariants.findIndex(v => (v.stock !== undefined ? v.stock : 0) > 0);
        if (defaultSelectedIndex === -1) defaultSelectedIndex = 0;

        condSelect.innerHTML = versionVariants.map((v, idx) => {
            const isSel = idx === defaultSelectedIndex ? "selected" : "";
            const priceStr = v.price <= 0 ? "Price Error" : `$${v.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            const stockStr = (v.stock !== undefined ? v.stock : 0) <= 0 ? " (Out of Stock)" : ` (${v.stock} in stock)`;
            const displayTitle = v.title || v.option1 || `Version ${idx + 1}`;
            return `<option value="${v.id}" ${isSel}>${displayTitle} - ${priceStr}${stockStr}</option>`;
        }).join("");

        const isPreorder = card.tags && card.tags.includes('pre-order');
        const isUnavailableModal = card.tags && card.tags.includes('unavailable');
        const updateModalForSelectedVariant = (variant) => {
            // Photo switching logic: switch to variant photo if present, else default product photo
            const modalImg = document.getElementById("modal-card-image");
            if (modalImg) {
                let vPhoto = variant.image;
                if (!vPhoto && variant.featured_image) {
                    vPhoto = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
                }
                if (vPhoto && typeof vPhoto === 'string' && vPhoto.trim() !== '') {
                    modalImg.src = vPhoto;
                } else {
                    modalImg.src = card.image; // fallback to default photo
                }
            }

            const isPriceError = (variant.price || 0) <= 0;
            if (isUnavailableModal) {
                price.textContent = '';
                price.style.display = 'none';
                stock.innerHTML = `<i class="fa-solid fa-ban text-red"></i> Currently Unavailable`;
                addBtn.disabled = true;
                addBtn.innerHTML = `<i class="fa-solid fa-ban"></i> Unavailable`;
                addBtn.style.backgroundColor = '#6b7280';
                addBtn.style.borderColor = '#6b7280';
                addBtn.onclick = null;
            } else if (isPriceError) {
                price.innerHTML = `<span style="color: #ef4444; font-weight: bold;">Price Error</span>`;
                stock.innerHTML = `<i class="fa-solid fa-warehouse text-red"></i> Unavailable`;
                addBtn.disabled = true;
                addBtn.innerHTML = `<i class="fa-solid fa-triangle-exclamation"></i> Price Error`;
                addBtn.onclick = null;
            } else {
                price.textContent = `$${variant.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                const vStock = variant.stock !== undefined ? variant.stock : 0;
                const vOutOfStock = vStock <= 0;
                if (vOutOfStock) {
                    stock.innerHTML = isPreorder
                        ? `<i class="fa-solid fa-clock text-red"></i> Pre-Orders Closed`
                        : `<i class="fa-solid fa-warehouse text-red"></i> Out of Stock`;
                    addBtn.disabled = true;
                    addBtn.textContent = isPreorder ? "Pre-Orders Closed" : "Out of Stock";
                    addBtn.onclick = null;
                } else {
                    stock.innerHTML = isPreorder
                        ? `<i class="fa-solid fa-clock" style="color: #fbbf24;"></i> Pre-Order Item (${vStock} available)`
                        : `<i class="fa-solid fa-warehouse text-green"></i> ${vStock} in stock`;
                    addBtn.disabled = false;
                    addBtn.innerHTML = isPreorder
                        ? `<i class="fa-solid fa-calendar-plus"></i> Pre-Order`
                        : `<i class="fa-solid fa-plus"></i> Add to Cart`;
                    addBtn.onclick = () => {
                        addToCart(card.id, "tcg", variant.id);
                        closeCardModal();
                    };
                }
            }
        };

        condSelect.onchange = (e) => {
            const selectedId = parseInt(e.target.value, 10);
            const variant = versionVariants.find(v => v.id === selectedId);
            if (variant) {
                updateModalForSelectedVariant(variant);
            }
        };

        updateModalForSelectedVariant(versionVariants[defaultSelectedIndex]);
    } else if (!isAnyGraded && card.variants && card.variants.length > 0) {
        const sortedCondVariants = card.variants.filter(v => getVariantCondition(v) !== null);
        sortedCondVariants.sort((a, b) => CONDITION_HIERARCHY.indexOf(getVariantCondition(a)) - CONDITION_HIERARCHY.indexOf(getVariantCondition(b)));

        if (sortedCondVariants.length > 0) {
            if (selectorLabel) selectorLabel.textContent = "Condition:";
            condContainer.style.display = "block";

            // Find the index of the in-stock variant with the highest price
            let defaultSelectedIndex = -1;
            let highestInStockPrice = -1;
            sortedCondVariants.forEach((v, idx) => {
                const stock = v.stock !== undefined ? v.stock : 0;
                if (stock > 0 && (v.price || 0) > highestInStockPrice) {
                    highestInStockPrice = v.price || 0;
                    defaultSelectedIndex = idx;
                }
            });
            if (defaultSelectedIndex === -1) defaultSelectedIndex = 0;

            condSelect.innerHTML = sortedCondVariants.map((v, idx) => {
                const isSel = idx === defaultSelectedIndex ? "selected" : "";
                const priceStr = v.price <= 0 ? "Price Error" : `$${v.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                const stockStr = (v.stock !== undefined ? v.stock : 0) <= 0 ? " (Out of Stock)" : ` (${v.stock} in stock)`;
                const displayCond = getVariantCondition(v) || v.option1 || v.title || 'Condition';
                return `<option value="${v.id}" ${isSel}>${displayCond} - ${priceStr}${stockStr}</option>`;
            }).join("");

            const isPreorder = card.tags && card.tags.includes('pre-order');
            const isUnavailableModal = card.tags && card.tags.includes('unavailable');
            const updateModalForSelectedVariant = (variant) => {
                // Photo switching logic for condition variants if image is present
                const modalImg = document.getElementById("modal-card-image");
                if (modalImg) {
                    let vPhoto = variant.image;
                    if (!vPhoto && variant.featured_image) {
                        vPhoto = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
                    }
                    if (vPhoto && typeof vPhoto === 'string' && vPhoto.trim() !== '') {
                        modalImg.src = vPhoto;
                    } else {
                        modalImg.src = card.image; // fallback to default photo
                    }
                }

                const isPriceError = (variant.price || 0) <= 0;
                if (isUnavailableModal) {
                    price.textContent = '';
                    price.style.display = 'none';
                    stock.innerHTML = `<i class="fa-solid fa-ban text-red"></i> Currently Unavailable`;
                    addBtn.disabled = true;
                    addBtn.innerHTML = `<i class="fa-solid fa-ban"></i> Unavailable`;
                    addBtn.style.backgroundColor = '#6b7280';
                    addBtn.style.borderColor = '#6b7280';
                    addBtn.onclick = null;
                } else if (isPriceError) {
                    price.innerHTML = `<span style="color: #ef4444; font-weight: bold;">Price Error</span>`;
                    stock.innerHTML = `<i class="fa-solid fa-warehouse text-red"></i> Unavailable`;
                    addBtn.disabled = true;
                    addBtn.innerHTML = `<i class="fa-solid fa-triangle-exclamation"></i> Price Error`;
                    addBtn.onclick = null;
                } else {
                    price.textContent = `$${variant.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                    const vStock = variant.stock !== undefined ? variant.stock : 0;
                    const vOutOfStock = vStock <= 0;
                    if (vOutOfStock) {
                        stock.innerHTML = isPreorder
                            ? `<i class="fa-solid fa-clock text-red"></i> Pre-Orders Closed`
                            : `<i class="fa-solid fa-warehouse text-red"></i> Out of Stock`;
                        addBtn.disabled = true;
                        addBtn.textContent = isPreorder ? "Pre-Orders Closed" : "Out of Stock";
                        addBtn.onclick = null;
                    } else {
                        stock.innerHTML = isPreorder
                            ? `<i class="fa-solid fa-clock" style="color: #fbbf24;"></i> Pre-Order Item (${vStock} available)`
                            : `<i class="fa-solid fa-warehouse text-green"></i> ${vStock} in stock`;
                        addBtn.disabled = false;
                        addBtn.innerHTML = isPreorder
                            ? `<i class="fa-solid fa-calendar-plus"></i> Pre-Order`
                            : `<i class="fa-solid fa-plus"></i> Add to Cart`;
                        addBtn.onclick = () => {
                            addToCart(card.id, "tcg", variant.id);
                            closeCardModal();
                        };
                    }
                }
            };

            condSelect.onchange = (e) => {
                const selectedId = parseInt(e.target.value, 10);
                const variant = sortedCondVariants.find(v => v.id === selectedId);
                if (variant) {
                    updateModalForSelectedVariant(variant);
                }
            };

            updateModalForSelectedVariant(sortedCondVariants[defaultSelectedIndex]);
        } else {
            condContainer.style.display = "none";
            setDefaultModalPricing(card, price, stock, addBtn);
        }
    } else {
        condContainer.style.display = "none";
        setDefaultModalPricing(card, price, stock, addBtn);
    }



    modal.classList.remove("hidden");
    document.body.style.overflow = "hidden";
}

function setDefaultModalPricing(card, price, stock, addBtn) {
    const isPreorder = card.tags && card.tags.includes('pre-order');
    const isUnavailable = card.tags && card.tags.includes('unavailable');
    const isPriceError = card.basePrice <= 0;
    if (isPriceError) {
        price.innerHTML = `<span style="color: #ef4444; font-weight: bold;">Price Error</span>`;
    } else {
        price.textContent = `$${card.basePrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
    const isOutOfStock = card.stock <= 0;
    if (isUnavailable) {
        price.textContent = '';
        price.style.display = 'none';
        stock.innerHTML = `<i class="fa-solid fa-ban text-red"></i> Currently Unavailable`;
        addBtn.disabled = true;
        addBtn.innerHTML = `<i class="fa-solid fa-ban"></i> Unavailable`;
        addBtn.style.backgroundColor = '#6b7280';
        addBtn.style.borderColor = '#6b7280';
        addBtn.onclick = null;
    } else if (isPriceError) {
        stock.innerHTML = `<i class="fa-solid fa-warehouse text-red"></i> Unavailable`;
        addBtn.disabled = true;
        addBtn.innerHTML = `<i class="fa-solid fa-triangle-exclamation"></i> Price Error`;
        addBtn.onclick = null;
    } else if (isOutOfStock) {
        stock.innerHTML = isPreorder
            ? `<i class="fa-solid fa-clock text-red"></i> Pre-Orders Closed`
            : `<i class="fa-solid fa-warehouse text-red"></i> Out of Stock`;
        addBtn.disabled = true;
        addBtn.textContent = isPreorder ? "Pre-Orders Closed" : "Out of Stock";
        addBtn.onclick = null;
    } else {
        stock.innerHTML = isPreorder
            ? `<i class="fa-solid fa-clock" style="color: #fbbf24;"></i> Pre-Order Item (${card.stock} available)`
            : `<i class="fa-solid fa-warehouse text-green"></i> ${card.stock} in stock`;
        addBtn.disabled = false;
        addBtn.innerHTML = isPreorder
            ? `<i class="fa-solid fa-calendar-plus"></i> Pre-Order`
            : `<i class="fa-solid fa-plus"></i> Add to Cart`;
        addBtn.onclick = () => {
            addToCart(card.id, "tcg");
            closeCardModal();
        };
    }
}

// Close Card Details Modal
function closeCardModal() {
    const modal = document.getElementById("card-modal");
    if (modal) {
        modal.classList.add("hidden");
        document.body.style.overflow = "";

        // Reset zoom states
        const zoomedElements = modal.querySelectorAll('.zoomed');
        zoomedElements.forEach(el => el.classList.remove('zoomed'));
    }
}

// --- LOGIC FUNCTIONS ---

// Product pages carry their own variant data, including products outside the TCG catalog.
function addProductPageItemToCart(product, variantId, quantity) {
    const variant = product.variants.find(item => Number(item.id) === Number(variantId));
    if (!Number.isSafeInteger(quantity) || quantity < 1 || !variant) {
        showToast("Cannot add product", "Choose a variant and a valid quantity.", true);
        return false;
    }
    if (isInStoreOnly(product) || (product.tags || []).includes('unavailable')) {
        showToast("Unavailable online", "This product cannot be purchased online.", true);
        return false;
    }
    if (!variant.available) {
        showToast("Out of Stock", "This variant is currently out of stock.", true);
        return false;
    }
    const existing = cart.find(item => item.type === 'tcg' && Number(item.id) === Number(product.id) && Number(item.variantId) === Number(variant.id));
    const totalQuantity = (existing ? existing.qty : 0) + quantity;
    if (variant.stock !== null && totalQuantity > variant.stock) {
        showToast("Limited Stock", `Only ${variant.stock} available for this specific variant.`, true);
        return false;
    }
    if (existing) {
        existing.qty = totalQuantity;
        existing.price = variant.price;
        existing.maxStock = variant.stock;
    } else {
        cart.push({
            id: Number(product.id), variantId: Number(variant.id), type: 'tcg',
            name: product.name, price: variant.price,
            variant: variant.title === 'Default Title' ? '' : variant.title,
            image: product.image, qty: quantity, maxStock: variant.stock
        });
    }
    updateCartTotals();
    animateFlyToCart(product.id, product.image);
    return true;
}

function setupMainProductCart() {
    const data = document.getElementById('main-product-cart-data');
    const button = document.getElementById('main-product-submit-btn');
    if (!data || !button || !button.form) return;
    const product = JSON.parse(data.textContent);
    button.form.addEventListener('submit', event => {
        event.preventDefault();
        const fields = new FormData(button.form);
        if (addProductPageItemToCart(product, fields.get('id'), Number(fields.get('quantity') || 1))) {
            showToast("Added to cart", product.name);
        }
    });
}

// Add item to Cart
function addToCart(itemId, type, variantId = null) {
    const numericId = parseInt(itemId, 10);
    if (!isNaN(numericId)) {
        itemId = numericId;
    }

    // Tournament entries need player details before they can be purchased.
    const eventProduct = allShopifyProducts.find(product => Number(product.id) === itemId);
    if (itemId === 9022665031858 || eventProduct?.isEvent) {
        const product = eventProduct;
        if (product && product.handle) {
            const root = window.Shopify?.routes?.root || '/';
            window.location.href = `${root}products/${encodeURIComponent(product.handle)}`;
        } else {
            showToast('Player details required', 'Open the tournament product page to register your player.', true);
        }
        return;
    }

    let item;
    let name;
    let price;
    let variant = "";
    let image;
    let card = null;
    let selectedVariant = null;

    if (type === "tcg") {
        card = tcgInventory.find(c => c.id === itemId);
        if (!card) return;
        if (isInStoreOnly(card)) {
            showToast("Available in store", "This product is available in store only.");
            return;
        }
        item = card;
        name = card.name;
        image = card.image;

        if (variantId !== null) {
            const vId = parseInt(variantId, 10);
            selectedVariant = card.variants ? card.variants.find(v => v.id === vId || v.id === variantId) : null;
        } else {
            // Find highest priced condition variant in stock
            const isPsaGraded = card.psa && card.psa !== "Raw" && card.psa !== "Sealed";
            const isBgsGraded = !!card.bgsGrade;
            const isAnyGraded = isPsaGraded || isBgsGraded || !!card.tagGrade || !!card.cgcGrade || !!card.mintGrade;
            if (!isAnyGraded && card.variants && card.variants.length > 0) {
                const condVariants = card.variants.filter(v => getVariantCondition(v) !== null);

                if (condVariants.length > 0) {
                    // Find the in-stock variant with the highest price
                    let bestVariant = null;
                    let highestInStockPrice = -1;
                    condVariants.forEach(v => {
                        const stock = v.stock !== undefined ? v.stock : 0;
                        if (stock > 0 && (v.price || 0) > highestInStockPrice) {
                            highestInStockPrice = v.price || 0;
                            bestVariant = v;
                        }
                    });

                    selectedVariant = bestVariant;
                    if (!selectedVariant) {
                        // Fallback to highest-hierarchy condition variant
                        condVariants.sort((a, b) => CONDITION_HIERARCHY.indexOf(getVariantCondition(a)) - CONDITION_HIERARCHY.indexOf(getVariantCondition(b)));
                        selectedVariant = condVariants[0];
                    }
                } else {
                    selectedVariant = card.variants[0];
                }
            } else if (card.variants && card.variants.length > 0) {
                selectedVariant = card.variants[0];
            }
        }

        let finishStr = card.finish && card.finish !== "Non-Foil" ? ` ${card.finish}` : "";
        if (selectedVariant) {
            price = selectedVariant.price;
            item = { ...card, stock: selectedVariant.stock !== undefined ? selectedVariant.stock : card.stock };
            variantId = selectedVariant.id;

            const getOptName = (opt) => (typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : '')).toLowerCase();
            let detailsParts = [];

            if (card.psa && card.psa !== "Raw" && card.psa !== "Sealed") {
                detailsParts.push(`PSA ${card.psa} Graded`);
            } else if (card.bgsGrade) {
                detailsParts.push(`BGS ${card.bgsGrade} Graded`);
            } else if (card.tagGrade) {
                detailsParts.push(`TAG ${card.tagGrade} Graded`);
            } else if (card.cgcGrade) {
                detailsParts.push(`CGC ${card.cgcGrade} Graded`);
            } else if (card.mintGrade) {
                detailsParts.push(`Mint ${card.mintGrade} Graded`);
            } else if (card.format === "Sealed") {
                detailsParts.push(`Sealed Product`);
            } else {
                let versionVal = "";
                let conditionVal = "";

                // 1. Inspect card.options array if available
                if (card.options && Array.isArray(card.options) && card.options.length > 0) {
                    card.options.forEach((opt, idx) => {
                        const optName = getOptName(opt);
                        const val = (selectedVariant[`option${idx + 1}`] || "").trim();
                        if (!val || ["title", "default title", "default"].includes(val.toLowerCase())) return;

                        if (optName.includes("condition")) {
                            conditionVal = normalizeCondition(val) || val;
                        } else if (optName.includes("version") || optName.includes("edition") || optName.includes("style") || optName.includes("art") || optName.includes("variant") || optName.includes("sub-set") || optName.includes("type")) {
                            versionVal = val;
                        }
                    });
                }

                // 2. Parse option1, option2, option3 if version or condition still unset
                const rawOpts = [selectedVariant.option1, selectedVariant.option2, selectedVariant.option3].filter(Boolean);
                rawOpts.forEach(rawVal => {
                    const trimmed = String(rawVal).trim();
                    if (!trimmed || ["title", "default title", "default"].includes(trimmed.toLowerCase())) return;

                    const norm = normalizeCondition(trimmed);
                    if (norm) {
                        if (!conditionVal) conditionVal = norm;
                    } else {
                        if (!versionVal) {
                            versionVal = trimmed;
                        } else if (!versionVal.includes(trimmed)) {
                            versionVal += ` / ${trimmed}`;
                        }
                    }
                });

                // 3. Fallback to variant title if version is still unset
                if (!versionVal && selectedVariant.title) {
                    const titleStr = String(selectedVariant.title).trim();
                    if (titleStr && !["title", "default title", "default"].includes(titleStr.toLowerCase())) {
                        const parts = titleStr.split(/[\/\-]/).map(s => s.trim()).filter(Boolean);
                        const nonCondParts = [];
                        parts.forEach(p => {
                            const norm = normalizeCondition(p);
                            if (norm) {
                                if (!conditionVal) conditionVal = norm;
                            } else if (!["title", "default title", "default"].includes(p.toLowerCase())) {
                                nonCondParts.push(p);
                            }
                        });
                        if (nonCondParts.length > 0) {
                            versionVal = nonCondParts.join(" / ");
                        }
                    }
                }

                // Fallback to card level condition if missing
                if (!conditionVal && card.condition) {
                    conditionVal = normalizeCondition(card.condition) || card.condition;
                }

                if (versionVal) {
                    detailsParts.push(versionVal);
                }
                if (conditionVal && !detailsParts.includes(conditionVal)) {
                    detailsParts.push(conditionVal);
                }
                if (detailsParts.length === 0) {
                    detailsParts.push(finishStr ? finishStr.trim() : "Raw Card");
                }
            }

            if (finishStr && !detailsParts.some(p => p.includes(finishStr.trim()))) {
                detailsParts.push(finishStr.trim());
            }

            if (card.set) {
                variant = `${detailsParts.join(" - ")} (${card.set})`;
            } else {
                variant = detailsParts.join(" - ");
            }
        } else {
            price = card.basePrice;
            let detailsParts = [];
            if (card.psa && card.psa !== "Raw" && card.psa !== "Sealed") {
                detailsParts.push(`PSA ${card.psa} Graded`);
            } else if (card.bgsGrade) {
                detailsParts.push(`BGS ${card.bgsGrade} Graded`);
            } else if (card.tagGrade) {
                detailsParts.push(`TAG ${card.tagGrade} Graded`);
            } else if (card.cgcGrade) {
                detailsParts.push(`CGC ${card.cgcGrade} Graded`);
            } else if (card.mintGrade) {
                detailsParts.push(`Mint ${card.mintGrade} Graded`);
            } else if (card.format === "Sealed") {
                detailsParts.push(`Sealed Product`);
            } else {
                if (card.condition) {
                    detailsParts.push(normalizeCondition(card.condition) || card.condition);
                }
            }

            if (finishStr && !detailsParts.some(p => p.includes(finishStr.trim()))) {
                detailsParts.push(finishStr.trim());
            }
            if (detailsParts.length === 0) {
                detailsParts.push("Raw Card");
            }

            if (card.set) {
                variant = `${detailsParts.join(" - ")} (${card.set})`;
            } else {
                variant = detailsParts.join(" - ");
            }
        }
    } else {
        const cafeItem = CAFE_INVENTORY.find(i => i.id === itemId);
        if (!cafeItem) return;
        item = cafeItem;
        name = cafeItem.name;
        price = cafeItem.price;
        image = cafeItem.image;
        variant = "Café Item";
    }

    if (price <= 0) {
        showToast("Price Error", "This item has a price error and cannot be added to the cart.", true);
        return;
    }

    const resolvedVariantId = selectedVariant ? selectedVariant.id : (variantId !== null ? parseInt(variantId, 10) : null);
    const targetStock = selectedVariant ? (selectedVariant.stock !== undefined ? selectedVariant.stock : (card ? card.stock : 0)) : (card && card.stock !== undefined ? card.stock : 0);

    const existing = cart.find(i => {
        if (i.type !== type) return false;
        if (i.id !== itemId) return false;
        if (resolvedVariantId && i.variantId) {
            return parseInt(i.variantId, 10) === parseInt(resolvedVariantId, 10);
        }
        return i.variant === variant;
    });

    if (existing) {
        if (type === "tcg" && existing.qty >= targetStock) {
            showToast("Limited Stock!", `Only ${targetStock} copy/copies of this specific variant available.`, true);
            return;
        }
        existing.qty += 1;
    } else {
        if (type === "tcg" && targetStock <= 0) {
            showToast("Out of Stock", "This variant is currently out of stock.", true);
            return;
        }
        cart.push({
            id: itemId,
            variantId: resolvedVariantId,
            type,
            name,
            price,
            variant,
            image,
            qty: 1
        });
    }

    updateCartTotals();
    animateFlyToCart(itemId, image);
}

/**
 * Creates a flying image animation from the product card/modal image to the bottom-right floating cart button.
 */
function animateFlyToCart(itemId, imageSrc) {
    const floatingCartBtn = document.getElementById("floating-cart-btn");
    if (!floatingCartBtn) return;

    // 1. Locate source image element on page
    let sourceImg = null;

    // Check if card modal is currently open and visible
    const cardModal = document.getElementById("card-modal");
    if (cardModal && !cardModal.classList.contains("hidden")) {
        sourceImg = document.getElementById("modal-card-image") || cardModal.querySelector(".card-modal-image-panel img");
    }

    // If not in modal, check grid item by card id
    if (!sourceImg && itemId) {
        const gridItem = document.querySelector(`[data-card-id="${itemId}"]`);
        if (gridItem) {
            sourceImg = gridItem.querySelector("img");
        }
    }

    // Check main product page image
    if (!sourceImg) {
        sourceImg = document.getElementById("main-product-image");
    }

    let startX, startY, startW, startH;

    if (sourceImg && sourceImg.getBoundingClientRect) {
        const rect = sourceImg.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0) {
            startX = rect.left;
            startY = rect.top;
            startW = rect.width;
            startH = rect.height;
        }
    }

    // Fallback if no source element visible
    if (startX === undefined) {
        startW = 80;
        startH = 80;
        startX = (window.innerWidth / 2) - 40;
        startY = (window.innerHeight / 2) - 40;
    }

    // Target coordinates: center of floatingCartBtn (bottom-right)
    const targetRect = floatingCartBtn.getBoundingClientRect();
    const targetX = targetRect.left + (targetRect.width / 2);
    const targetY = targetRect.top + (targetRect.height / 2);

    // Create flying clone element
    const flyImg = document.createElement("img");
    flyImg.src = imageSrc || (sourceImg ? sourceImg.src : "");
    flyImg.className = "flying-product-img";
    flyImg.style.position = "fixed";
    flyImg.style.left = `${startX}px`;
    flyImg.style.top = `${startY}px`;
    flyImg.style.width = `${startW}px`;
    flyImg.style.height = `${startH}px`;
    flyImg.style.zIndex = "10000";
    flyImg.style.borderRadius = "12px";
    flyImg.style.boxShadow = "0 10px 25px rgba(61, 27, 92, 0.4), 0 0 0 2px #d4af37";
    flyImg.style.pointerEvents = "none";
    flyImg.style.objectFit = "cover";
    flyImg.style.transition = "all 0.65s cubic-bezier(0.2, 0.8, 0.25, 1)";

    document.body.appendChild(flyImg);

    // Trigger transition after render
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            const destX = targetX - (startX + startW / 2);
            const destY = targetY - (startY + startH / 2);

            flyImg.style.transform = `translate(${destX}px, ${destY}px) scale(0.12) rotate(15deg)`;
            flyImg.style.opacity = "0.2";
        });
    });

    // Cleanup and trigger button pulse
    setTimeout(() => {
        if (flyImg && flyImg.parentNode) {
            flyImg.parentNode.removeChild(flyImg);
        }
        floatingCartBtn.classList.add("pulse");
        setTimeout(() => floatingCartBtn.classList.remove("pulse"), 400);
    }, 650);
}

// Modify cart quantities
function updateCartQty(index, change) {
    const item = cart[index];
    if (!item) return;

    item.qty += change;

    if (item.qty <= 0) {
        cart.splice(index, 1);
    } else if (item.type === "tcg" && Object.prototype.hasOwnProperty.call(item, 'maxStock')) {
        if (item.maxStock !== null && item.qty > item.maxStock) {
            item.qty = item.maxStock;
            showToast("Limited Stock", `Only ${item.maxStock} available for this specific variant.`, true);
        }
    } else if (item.type === "tcg") {
        const inventoryItem = tcgInventory.find(c => c.id === item.id);
        if (inventoryItem) {
            let maxStock = inventoryItem.stock;
            if (item.variantId && inventoryItem.variants) {
                const variant = inventoryItem.variants.find(v => v.id === item.variantId || v.id === parseInt(item.variantId, 10));
                if (variant) {
                    maxStock = variant.stock !== undefined ? variant.stock : maxStock;
                }
            }
            if (item.qty > maxStock) {
                item.qty = maxStock;
                showToast("Limited Stock", `Only ${maxStock} available for this specific variant.`, true);
            }
        }
    }

    updateCartTotals();
}

// Remove item from Cart
function removeCartItem(index) {
    cart.splice(index, 1);
    updateCartTotals();
}

// Calculate taxes and sums, update cart UI
function updateCartTotals() {
    const cartBadge = document.getElementById("cart-badge");
    const cartContainer = document.getElementById("cart-items-container");
    const subtotalLabel = document.getElementById("cart-subtotal");
    const taxLabel = document.getElementById("cart-tax");
    const totalLabel = document.getElementById("cart-total");
    const checkoutBtn = document.getElementById("checkout-btn");

    if (!cartBadge) return; // Guard

    // Save cart state
    saveCart();

    const totalQty = cart.reduce((acc, i) => acc + i.qty, 0);

    // Update badge values & trigger pulse animation if quantity changed
    const prevBadgeVal = parseInt(cartBadge.textContent, 10) || 0;
    cartBadge.textContent = totalQty;

    const floatingCartBadge = document.getElementById("floating-cart-badge");
    if (floatingCartBadge) {
        floatingCartBadge.textContent = totalQty;
    }

    if (prevBadgeVal !== totalQty) {
        cartBadge.classList.add("pulse");
        if (floatingCartBadge) floatingCartBadge.classList.add("pulse");
        setTimeout(() => {
            cartBadge.classList.remove("pulse");
            if (floatingCartBadge) floatingCartBadge.classList.remove("pulse");
        }, 300);
    }

    toggleFloatingCartVisibility();

    if (cart.length === 0) {
        cartContainer.innerHTML = `
            <div class="empty-cart-message">
                <i class="fa-solid fa-bag-shopping"></i>
                <p>Your cart is empty. Browse singles or view the menu to begin!</p>
            </div>
        `;
        subtotalLabel.textContent = "$0.00";
        taxLabel.textContent = "$0.00";
        totalLabel.textContent = "$0.00";
        checkoutBtn.disabled = true;
        return;
    }

    checkoutBtn.disabled = false;
    cartContainer.innerHTML = "";

    let subtotal = 0;
    let cardTaxes = 0;
    let cafeTaxes = 0;

    cart.forEach((item, index) => {
        const itemCost = item.price * item.qty;
        subtotal += itemCost;

        if (item.type === "tcg") {
            cardTaxes += itemCost * 0.10;
        } else {
            cafeTaxes += itemCost * 0.085;
        }

        const row = document.createElement("div");
        row.className = "cart-item-row";

        const imgClass = item.type === "cafe" ? "cart-item-row-img cafe-product" : "cart-item-row-img";

        row.innerHTML = `
            <div class="${imgClass}">
                <img src="${item.image}" alt="${item.name}">
            </div>
            <div class="cart-item-row-details">
                <div>
                    <h4 class="cart-item-row-name">${item.name}</h4>
                    <span class="cart-item-row-variant">${item.variant}</span>
                </div>
                <div class="cart-item-row-actions">
                    <div class="quantity-picker">
                        <button class="cart-qty-minus" data-index="${index}"><i class="fa-solid fa-minus"></i></button>
                        <span>${item.qty}</span>
                        <button class="cart-qty-plus" data-index="${index}"><i class="fa-solid fa-plus"></i></button>
                    </div>
                    <button class="remove-item-btn" data-index="${index}"><i class="fa-solid fa-trash"></i></button>
                </div>
            </div>
            <div class="cart-item-row-price">
                $${itemCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
        `;

        cartContainer.appendChild(row);
    });

    const finalTotal = subtotal;

    subtotalLabel.textContent = `$${subtotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    taxLabel.textContent = "Calculated at checkout";
    totalLabel.textContent = `$${finalTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Toggle floating cart button visibility based on cart contents
function toggleFloatingCartVisibility() {
    const floatingCartBtn = document.getElementById("floating-cart-btn");
    if (!floatingCartBtn) return;

    const totalQty = cart.reduce((acc, i) => acc + i.qty, 0);

    if (totalQty > 0) {
        floatingCartBtn.classList.add("visible");
    } else {
        floatingCartBtn.classList.remove("visible");
    }
}

// Show Shopify Checkout Modal (Interceptors for live checkout redirect)
function renderCheckoutModal() {
    const modal = document.getElementById("checkout-modal");
    const summaryItems = document.getElementById("checkout-summary-items");

    const subtotalLabel = document.getElementById("summary-subtotal");
    const taxLabel = document.getElementById("summary-tax");
    const totalLabel = document.getElementById("summary-total");
    const payTotalBtn = document.getElementById("checkout-pay-total");

    if (!modal || !summaryItems) return;

    summaryItems.innerHTML = "";

    let subtotal = 0;
    let cardTaxes = 0;
    let cafeTaxes = 0;

    cart.forEach(item => {
        const itemCost = item.price * item.qty;
        subtotal += itemCost;
        if (item.type === "tcg") {
            cardTaxes += itemCost * 0.10;
        } else {
            cafeTaxes += itemCost * 0.085;
        }

        const row = document.createElement("div");
        row.className = "summary-item-row";
        row.innerHTML = `
            <div class="summary-item-info">
                <span class="summary-item-qty">x${item.qty}</span>
                <span class="summary-item-name">${item.name} <small class="text-muted" style="font-size:0.75rem">${item.variant.split(' (')[0]}</small></span>
            </div>
            <span class="summary-item-price">$${itemCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        `;
        summaryItems.appendChild(row);
    });

    const deliveryRadioEl = document.querySelector('input[name="delivery"]:checked');
    const hasShipping = deliveryRadioEl ? deliveryRadioEl.value === "shipping" : false;
    const isFreeShipping = hasShipping && subtotal >= 150;
    const shippingCost = hasShipping ? (isFreeShipping ? 0.00 : 4.99) : 0.00;

    const shippingBadge = document.getElementById("checkout-shipping-badge");
    if (shippingBadge) {
        shippingBadge.textContent = subtotal >= 150 ? "FREE" : "$4.99";
    }

    const taxes = cardTaxes + cafeTaxes;
    const total = subtotal + taxes + shippingCost;

    subtotalLabel.textContent = `$${subtotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const summaryShippingEl = document.getElementById("summary-shipping");
    if (summaryShippingEl) {
        if (!hasShipping) {
            summaryShippingEl.textContent = "FREE";
        } else if (isFreeShipping) {
            summaryShippingEl.textContent = "FREE (Canada $150+)";
        } else {
            summaryShippingEl.textContent = "$4.99";
        }
    }
    taxLabel.textContent = `$${taxes.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    totalLabel.textContent = `$${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    payTotalBtn.textContent = `$${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    modal.classList.remove("hidden");
}

// Display toast notifications
function showToast(title, message, isWarning = false) {
    const toast = document.getElementById("success-notification");
    const titleEl = document.getElementById("notification-title");
    const msgEl = document.getElementById("notification-message");
    const icon = toast ? toast.querySelector("i") : null;

    if (!toast || !titleEl || !msgEl || !icon) return;

    titleEl.textContent = title;
    msgEl.textContent = message;

    if (isWarning) {
        toast.style.borderLeftColor = "var(--clr-red)";
        icon.className = "fa-solid fa-triangle-exclamation text-red";
        icon.style.color = "var(--clr-red)";
    } else {
        toast.style.borderLeftColor = "var(--clr-green)";
        icon.className = "fa-solid fa-circle-check text-green";
        icon.style.color = "var(--clr-green)";
    }

    toast.classList.remove("hidden");

    setTimeout(() => {
        toast.classList.add("hidden");
    }, 4000);
}

// Submit payment order
function submitOrder() {
    const email = document.getElementById("checkout-email").value;
    if (!email) {
        showToast("Error", "Please enter a valid email address.", true);
        return;
    }

    // Deduct stock of items from inventory if checkout succeeds
    const checkoutItems = [...cart];
    checkoutItems.forEach(item => {
        if (item.type === "tcg") {
            const match = tcgInventory.find(c => c.id === item.id);
            if (match) {
                if (item.variantId && match.variants) {
                    const variant = match.variants.find(v => v.id === item.variantId);
                    if (variant) {
                        variant.stock = Math.max(0, variant.stock - item.qty);
                    }
                    // Recompute overall product stock
                    const hasConditionOption = match.options && match.options[0] && match.options[0].toLowerCase() === "condition";
                    const isPsaGraded = match.psa && match.psa !== "Raw" && match.psa !== "Sealed";
                    const isBgsGraded = !!match.bgsGrade;
                    const isTagGraded = !!match.tagGrade;
                    const isCgcGraded = !!match.cgcGrade;
                    const isMintGraded = !!match.mintGrade;
                    const isAnyGraded = isPsaGraded || isBgsGraded || isTagGraded || isCgcGraded || isMintGraded;
                    if (!isAnyGraded && hasConditionOption) {
                        match.stock = match.variants.reduce((sum, v) => sum + (v.stock !== undefined ? v.stock : 0), 0);
                    } else {
                        match.stock = Math.max(0, match.stock - item.qty);
                    }
                } else {
                    match.stock = Math.max(0, match.stock - item.qty);
                }
            }
        }
    });

    // Reset cart
    cart = [];
    updateCartTotals();
    renderTCGGrid();

    // Close modals
    document.getElementById("checkout-modal").classList.add("hidden");
    document.getElementById("cart-sidebar").classList.add("hidden");

    // Show success banner
    showToast("Shopify Order Placed!", "Payment processed. Check your email for receipt & order pickup instructions.");
}

// --- EVENT LISTENERS ---
function setupEventListeners() {
    // Keep anchor destinations below both header rows, including after mobile reflow.
    const siteHeader = document.querySelector('.main-header');
    if (siteHeader && !siteHeader.dataset.scrollOffsetObserved) {
        const updateHeaderOffset = () => {
            document.documentElement.style.setProperty('--store-header-height', `${Math.ceil(siteHeader.getBoundingClientRect().height) + 16}px`);
        };
        updateHeaderOffset();
        if (typeof ResizeObserver !== 'undefined') {
            const headerObserver = new ResizeObserver(updateHeaderOffset);
            headerObserver.observe(siteHeader);
        } else {
            window.addEventListener('resize', updateHeaderOffset);
        }
        siteHeader.dataset.scrollOffsetObserved = 'true';
    }
    // Navigation bar anchors links smooth routing
    document.querySelectorAll(".nav-link").forEach(link => {
        link.addEventListener("click", (e) => {
            document.querySelectorAll(".nav-link").forEach(l => l.classList.remove("active"));
            e.currentTarget.classList.add("active");
        });
    });

    // Cart opening and closing
    const openCartBtn = document.getElementById("open-cart-btn");
    const floatingCartBtn = document.getElementById("floating-cart-btn");
    const closeCartBtn = document.getElementById("close-cart-btn");
    const cartOverlay = document.getElementById("cart-sidebar");

    if (openCartBtn && closeCartBtn && cartOverlay) {
        openCartBtn.addEventListener("click", () => cartOverlay.classList.remove("hidden"));
        if (floatingCartBtn) {
            floatingCartBtn.addEventListener("click", () => cartOverlay.classList.remove("hidden"));
        }
        closeCartBtn.addEventListener("click", () => cartOverlay.classList.add("hidden"));

        cartOverlay.addEventListener("click", (e) => {
            if (e.target === cartOverlay) cartOverlay.classList.add("hidden");
        });
    }

    // Scroll listener for floating cart button on TCG side
    window.addEventListener("scroll", toggleFloatingCartVisibility);

    // Checkout modal actions
    const checkoutBtn = document.getElementById("checkout-btn");
    const closeCheckoutBtn = document.getElementById("close-checkout-btn");
    const checkoutModal = document.getElementById("checkout-modal");

    if (checkoutBtn && closeCheckoutBtn && checkoutModal) {
        checkoutBtn.addEventListener("click", () => {
            const isLocal = window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1" ||
                window.location.protocol === "file:";
            if (isLocal) {
                renderCheckoutModal();
            } else {
                checkoutBtn.disabled = true;
                const originalText = checkoutBtn.innerHTML;
                checkoutBtn.innerHTML = '<span>Connecting to Checkout...</span> <i class="fa-solid fa-spinner fa-spin"></i>';

                // 1. Clear current Shopify cart session
                fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(() => {
                        // 2. Map custom cart items to Shopify variants
                        const itemsToAdd = cart
                            .filter(item => item.variantId)
                            .map(item => ({
                                id: parseInt(item.variantId, 10),
                                quantity: item.qty
                            }));

                        if (itemsToAdd.length === 0) {
                            showToast("Cart Empty", "No purchasable items in your cart.", true);
                            checkoutBtn.disabled = false;
                            checkoutBtn.innerHTML = originalText;
                            return;
                        }

                        // 3. Add items to Shopify cart session
                        return fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ items: itemsToAdd })
                        });
                    })
                    .then(res => {
                        if (res && res.ok) {
                            // 4. Redirect to native checkout
                            window.location.href = '/checkout';
                        } else {
                            throw new Error("Failed to add items to Shopify cart");
                        }
                    })
                    .catch(err => {
                        console.error("Shopify Checkout Error:", err);
                        showToast("Checkout Error", "Could not connect to Shopify checkout. Please try again.", true);
                        checkoutBtn.disabled = false;
                        checkoutBtn.innerHTML = originalText;
                    });
            }
        });
        closeCheckoutBtn.addEventListener("click", () => checkoutModal.classList.add("hidden"));

        checkoutModal.addEventListener("click", (e) => {
            if (e.target === checkoutModal) checkoutModal.classList.add("hidden");
        });
    }

    // Password storefront modal actions
    const openPasswordBtn = document.getElementById("open-password-btn");
    const closePasswordBtn = document.getElementById("close-password-modal-btn");
    const passwordModal = document.getElementById("password-login-modal");

    if (openPasswordBtn && closePasswordBtn && passwordModal) {
        openPasswordBtn.addEventListener("click", () => {
            passwordModal.classList.remove("hidden");
            const pwInput = document.getElementById("storefront-password-input");
            if (pwInput) pwInput.focus();
        });
        closePasswordBtn.addEventListener("click", () => passwordModal.classList.add("hidden"));

        passwordModal.addEventListener("click", (e) => {
            if (e.target === passwordModal) passwordModal.classList.add("hidden");
        });

        // Mock password form submit in local preview
        const storefrontPwForm = passwordModal.querySelector("form");
        if (storefrontPwForm) {
            storefrontPwForm.addEventListener("submit", (e) => {
                e.preventDefault();
                const pwInput = document.getElementById("storefront-password-input");
                if (!pwInput) return;

                const enteredPassword = pwInput.value;
                if (enteredPassword === "space") {
                    localStorage.setItem("storefront_authorized", "true");
                    showToast("Access Granted", "Bypassing portal lock...");
                    setTimeout(() => {
                        window.location.href = "index.html";
                    }, 1200);
                } else {
                    showToast("Access Denied", "Incorrect storefront password.", "error");
                    let errorBanner = passwordModal.querySelector(".form-error-banner");
                    if (!errorBanner) {
                        errorBanner = document.createElement("div");
                        errorBanner.className = "form-error-banner";
                        errorBanner.style.marginTop = "15px";
                        errorBanner.innerHTML = `<i class="fa-solid fa-triangle-exclamation"></i> <span>Incorrect password. Please try again.</span>`;
                        storefrontPwForm.appendChild(errorBanner);
                    }
                }
            });
        }
    }

    // Mock customer account forms submit
    const createCustomerForm = document.getElementById("create_customer");
    if (createCustomerForm) {
        createCustomerForm.addEventListener("submit", (e) => {
            const isLocal = window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1" ||
                window.location.protocol === "file:";
            if (isLocal) {
                e.preventDefault();
                const firstName = document.getElementById("FirstName").value;
                showToast("Account Created", `Welcome ${firstName}! Redirecting to login...`);
                setTimeout(() => {
                    window.location.href = "login.html";
                }, 1500);
            }
        });
    }

    const customerLoginForm = document.getElementById("customer_login");
    if (customerLoginForm) {
        customerLoginForm.addEventListener("submit", (e) => {
            const isLocal = window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1" ||
                window.location.protocol === "file:";
            if (isLocal) {
                e.preventDefault();
                const email = document.getElementById("CustomerEmail").value;
                showToast("Welcome Back!", `Logged in as ${email}. Redirecting to storefront...`);
                localStorage.setItem("spacesocial_customer_logged_in", "true");
                localStorage.setItem("spacesocial_customer_email", email);
                setTimeout(() => {
                    window.location.href = "index.html";
                }, 1500);
            }
        });
    }

    // Global and sidebar search filtering
    const globalSearch = document.getElementById("global-search");
    const filterSearch = document.getElementById("singles-filter-search");

    if (globalSearch) {
        globalSearch.addEventListener("input", () => {
            if (filterSearch) filterSearch.value = globalSearch.value;
            renderTCGGrid();
        });
    }

    if (filterSearch) {
        filterSearch.addEventListener("input", () => {
            if (globalSearch) globalSearch.value = filterSearch.value;
            renderTCGGrid();
        });
    }

    // Sorting Dropdown Trigger
    const sortDropdown = document.getElementById("catalog-sort");
    if (sortDropdown) {
        sortDropdown.addEventListener("change", renderTCGGrid);
    }

    // Checkbox filters
    document.querySelectorAll(".condition-filter, .psa-filter, .tag-filter, .cgc-filter, .mint-filter, .finish-filter, .format-filter").forEach(cb => {
        cb.addEventListener("change", renderTCGGrid);
    });

    // Grading company sub-menu toggles
    document.querySelectorAll(".grading-company-btn").forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.stopPropagation();
            const submenuId = btn.getAttribute("data-submenu");
            const submenu = document.getElementById(submenuId);
            if (!submenu) return;
            const isOpen = submenu.classList.contains("open");
            submenu.classList.toggle("open");
            btn.classList.toggle("expanded");
        });
    });

    const inStockToggle = document.getElementById("filter-in-stock-only");
    if (inStockToggle) {
        inStockToggle.addEventListener("change", renderTCGGrid);
    }

    // Debug owner filter buttons removed

    // Square the catalog toolbar's top corners only while it is pinned.
    const catalogFilterBar = document.querySelector('#tcg-catalog .catalog-filter-bar');
    if (catalogFilterBar) {
        let stickyFrame = null;
        const updateStickyCorners = () => {
            stickyFrame = null;
            catalogFilterBar.classList.toggle('is-stuck', catalogFilterBar.getBoundingClientRect().top <= 0);
        };
        const scheduleStickyCorners = () => {
            if (stickyFrame === null) stickyFrame = requestAnimationFrame(updateStickyCorners);
        };
        window.addEventListener('scroll', scheduleStickyCorners, { passive: true });
        window.addEventListener('resize', scheduleStickyCorners);
        updateStickyCorners();
    }

    // Filter pill dropdown toggles
    const filtersToggle = document.querySelector('.catalog-filters-toggle');
    const filterOptions = document.getElementById('catalog-filter-options');
    if (filtersToggle && filterOptions) {
        filtersToggle.addEventListener('click', () => {
            const expanded = filtersToggle.getAttribute('aria-expanded') !== 'true';
            filtersToggle.setAttribute('aria-expanded', String(expanded));
            filterOptions.classList.toggle('is-expanded', expanded);
            if (!expanded) {
                filterOptions.querySelectorAll('.filter-pill-group.active').forEach(group => group.classList.remove('active'));
            }
        });
    }

    document.querySelectorAll(".filter-pill-btn").forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.stopPropagation();
            const group = btn.closest(".filter-pill-group");
            const isActive = group.classList.contains("active");
            // Close all open dropdowns
            document.querySelectorAll(".filter-pill-group.active").forEach(g => g.classList.remove("active"));
            // Toggle clicked one
            if (!isActive) group.classList.add("active");
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener("click", (e) => {
        if (!e.target.closest(".filter-pill-group")) {
            document.querySelectorAll(".filter-pill-group.active").forEach(g => g.classList.remove("active"));
        }
    }, true);

    // Update pill "has-selection" state when checkboxes change
    function updatePillSelectionState() {
        if (filtersToggle && filterOptions) {
            const count = filterOptions.querySelectorAll('input[type="checkbox"]:checked').length;
            filtersToggle.querySelector('.catalog-filter-selection-count').textContent = count ? ` (${count})` : '';
        }
        document.querySelectorAll(".filter-pill-group").forEach(group => {
            const hasChecked = group.querySelector("input[type='checkbox']:checked");
            if (hasChecked) {
                group.classList.add("has-selection");
            } else {
                group.classList.remove("has-selection");
            }
        });
    }

    document.querySelectorAll(".filter-pill-group input[type='checkbox']").forEach(cb => {
        cb.addEventListener("change", updatePillSelectionState);
    });

    updatePillSelectionState();

    document.getElementById('catalog-set-search')?.addEventListener('input', filterCatalogSetOptions);
    document.getElementById('catalog-set-options')?.addEventListener('change', event => {
        if (!event.target.matches('.set-filter')) return;
        updatePillSelectionState();
        renderTCGGrid();
    });

    function syncPokemonSubfilterVisibility() {
        const subfilterBar = document.getElementById("pokemon-subfilter-bar");
        const langPill = document.getElementById("fpg-language");

        if (activeGame === "pokemon") {
            if (subfilterBar) subfilterBar.style.display = "";
            if (langPill) langPill.style.display = "";
        } else {
            if (subfilterBar) subfilterBar.style.display = "none";
            if (langPill) langPill.style.display = "none";
            window.activePokemonLang = "all";
            document.querySelectorAll(".language-filter").forEach(cb => cb.checked = false);
            document.querySelectorAll(".pokemon-lang-btn").forEach(b => {
                if (b.getAttribute("data-lang") === "all") b.classList.add("active");
                else b.classList.remove("active");
            });
        }
        updatePillSelectionState();
    }

    // TCG Catalog Game Selector Tabs
    document.querySelectorAll(".tab-btn").forEach(tab => {
        tab.addEventListener("click", (e) => {
            document.querySelectorAll(".tab-btn").forEach(t => t.classList.remove("active"));
            e.currentTarget.classList.add("active");
            activeGame = e.currentTarget.getAttribute("data-game");

            syncPokemonSubfilterVisibility();
            renderTCGGrid();
        });
    });

    syncPokemonSubfilterVisibility();

    // Pokémon Language Subfilter Buttons
    window.activePokemonLang = "all";

    document.querySelectorAll(".pokemon-lang-btn").forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelectorAll(".pokemon-lang-btn").forEach(b => b.classList.remove("active"));
            btn.classList.add("active");
            window.activePokemonLang = btn.getAttribute("data-lang") || "all";

            // Sync dropdown checkboxes if present
            document.querySelectorAll(".language-filter").forEach(cb => {
                if (window.activePokemonLang === "all") {
                    cb.checked = false;
                } else {
                    cb.checked = (cb.value === window.activePokemonLang);
                }
            });

            if (typeof updatePillSelectionState === "function") {
                updatePillSelectionState();
            }

            renderTCGGrid();
        });
    });

    // Language Dropdown Checkboxes
    document.querySelectorAll(".language-filter").forEach(cb => {
        cb.addEventListener("change", () => {
            const checkedLangs = Array.from(document.querySelectorAll(".language-filter:checked")).map(el => el.value);
            if (checkedLangs.length === 1) {
                window.activePokemonLang = checkedLangs[0];
            } else {
                window.activePokemonLang = "all";
            }

            // Sync subfilter buttons
            document.querySelectorAll(".pokemon-lang-btn").forEach(b => {
                if (b.getAttribute("data-lang") === window.activePokemonLang) {
                    b.classList.add("active");
                } else {
                    b.classList.remove("active");
                }
            });

            renderTCGGrid();
        });
    });

    // Cafe Menu Selector Category Buttons
    document.querySelectorAll(".cafe-cat-btn").forEach(tab => {
        tab.addEventListener("click", (e) => {
            document.querySelectorAll(".cafe-cat-btn").forEach(t => t.classList.remove("active"));
            e.currentTarget.classList.add("active");
            const activeCafeCat = e.currentTarget.getAttribute("data-category");

            document.querySelectorAll(".cafe-item-card").forEach(card => {
                const cat = card.getAttribute("data-category");
                if (activeCafeCat === "all" || cat === activeCafeCat) {
                    card.style.display = "";
                } else {
                    card.style.display = "none";
                }
            });
        });
    });

    // Initialize Cafe Menu to only show items matching the active category on load
    const initialActiveCafeTab = document.querySelector(".cafe-cat-btn.active");
    if (initialActiveCafeTab) {
        const activeCafeCat = initialActiveCafeTab.getAttribute("data-category");
        document.querySelectorAll(".cafe-item-card").forEach(card => {
            const cat = card.getAttribute("data-category");
            if (activeCafeCat === "all" || cat === activeCafeCat) {
                card.style.display = "";
            } else {
                card.style.display = "none";
            }
        });
    }

    // Checkout payment submission
    const checkoutSubmit = document.getElementById("complete-order-btn");
    if (checkoutSubmit) {
        checkoutSubmit.addEventListener("click", submitOrder);
    }

    // Close card details modal
    const closeCardModalBtn = document.getElementById("close-card-modal-btn");
    const cardModal = document.getElementById("card-modal");
    if (closeCardModalBtn && cardModal) {
        closeCardModalBtn.addEventListener("click", closeCardModal);
        cardModal.addEventListener("click", (e) => {
            if (e.target === cardModal) closeCardModal();
        });
    }

    // Delegated click listeners
    document.addEventListener("click", (e) => {
        // TCG Card buttons (Add to Cart)
        const addCartBtn = e.target.classList.contains("add-cart-card-btn") ? e.target : e.target.closest(".add-cart-card-btn");
        if (addCartBtn) {
            const cardId = addCartBtn.getAttribute("data-card-id");
            addToCart(cardId, "tcg");
            return;
        }

        // Prune Mode: Hide card from catalog button
        const pruneRemoveBtn = e.target.closest(".prune-remove-btn");
        if (pruneRemoveBtn) {
            e.stopPropagation();
            e.preventDefault();
            const uniqueId = pruneRemoveBtn.getAttribute("data-unique-id");
            if (uniqueId && window.hideCardFromCatalog) {
                window.hideCardFromCatalog(uniqueId, e);
            }
            return;
        }

        // Admin: Mark product as Can't Find button
        const cantFindBtn = e.target.closest(".admin-cant-find-btn");
        if (cantFindBtn) {
            e.stopPropagation();
            e.preventDefault();
            const cardId = cantFindBtn.getAttribute("data-card-id");
            if (cardId && window.markProductCantFind) {
                window.markProductCantFind(cardId, e);
            }
            return;
        }

        // Prune Mode: Copy card title on click
        const cardNameEl = e.target.closest(".card-name");
        if (cardNameEl && window.isPruneModeActive) {
            e.stopPropagation();
            const textToCopy = cardNameEl.getAttribute("data-copy-name") || cardNameEl.textContent.trim();
            if (textToCopy) {
                copyTextToClipboard(textToCopy).then((success) => {
                    if (success && typeof showToast === 'function') {
                        showToast("Copied", `Copied: ${textToCopy}`, 'success');
                    }
                }).catch(err => {
                    console.error('Clipboard copy failed:', err);
                });
            }
            return;
        }

        // Quick cart remove button
        const qcRemoveBtn = e.target.closest(".quick-cart-remove-btn");
        if (qcRemoveBtn) {
            e.stopPropagation();
            const idx = parseInt(qcRemoveBtn.getAttribute("data-idx"), 10);
            if (!isNaN(idx) && window.removeQuickCartItem) {
                window.removeQuickCartItem(idx);
            }
            return;
        }

        // Quick cart quantity change buttons
        const qcQtyBtn = e.target.closest(".quick-cart-qty-btn");
        if (qcQtyBtn) {
            e.stopPropagation();
            const idx = parseInt(qcQtyBtn.getAttribute("data-idx"), 10);
            const change = parseInt(qcQtyBtn.getAttribute("data-change"), 10);
            if (!isNaN(idx) && !isNaN(change) && window.updateQuickCartQty) {
                window.updateQuickCartQty(idx, change);
            }
            return;
        }

        // TCG Card details modal trigger
        const tcgCardItem = e.target.closest(".tcg-card-item");
        if (tcgCardItem) {
            if (e.target.closest('.prune-remove-btn')) return;
            if (e.target.closest('.admin-audit-btn')) return;
            if (e.target.closest('.admin-cant-find-btn')) return;
            if (e.target.closest('.cond-minus-btn')) return;
            if (e.target.closest('.admin-cond-item')) return;
            if (e.target.closest('.card-name') && window.isPruneModeActive) return;
            if (e.target.closest('.add-cart-card-btn')) return;
            if (e.target.closest('.card-version-select')) return;
            const cardId = parseInt(tcgCardItem.getAttribute("data-card-id"), 10);
            if (!isNaN(cardId)) {
                e.preventDefault();
                openCardModal(cardId);
            }
        }

        // Cart quantity minus
        if (e.target.classList.contains("cart-qty-minus") || e.target.closest(".cart-qty-minus")) {
            const btn = e.target.classList.contains("cart-qty-minus") ? e.target : e.target.closest(".cart-qty-minus");
            const idx = parseInt(btn.getAttribute("data-index"));
            updateCartQty(idx, -1);
        }

        // Cart quantity plus
        if (e.target.classList.contains("cart-qty-plus") || e.target.closest(".cart-qty-plus")) {
            const btn = e.target.classList.contains("cart-qty-plus") ? e.target : e.target.closest(".cart-qty-plus");
            const idx = parseInt(btn.getAttribute("data-index"));
            updateCartQty(idx, 1);
        }

        // Cart item removal
        if (e.target.classList.contains("remove-item-btn") || e.target.closest(".remove-item-btn")) {
            const btn = e.target.classList.contains("remove-item-btn") ? e.target : e.target.closest(".remove-item-btn");
            const idx = parseInt(btn.getAttribute("data-index"));
            removeCartItem(idx);
        }
    });

    // Delivery selection option checkout recalculation
    document.querySelectorAll('input[name="delivery"]').forEach(radio => {
        radio.addEventListener("change", (e) => {
            document.querySelectorAll(".delivery-radio").forEach(c => c.classList.remove("active"));
            e.currentTarget.closest(".delivery-radio").classList.add("active");
            renderCheckoutModal();
        });
    });

}

// --- PAGE TRANSITION HELPERS ---
function setupPageTransitions() {
    document.querySelectorAll("a").forEach(link => {
        if (isLocalTransitionLink(link)) {
            link.addEventListener("click", (e) => {
                const targetUrl = link.href;
                const transitionOverlay = document.getElementById("page-transition-overlay");
                if (transitionOverlay) {
                    e.preventDefault();
                    transitionOverlay.classList.remove("fade-out-active");
                    setTimeout(() => {
                        window.location.href = targetUrl;
                    }, 500); // match transition duration (0.5s)
                }
            });
        }
    });
}

function isLocalTransitionLink(link) {
    if (!link.href) return false;
    if (link.getAttribute("target") === "_blank") return false;
    if (link.classList.contains("panel-btn") || link.closest(".panel-btn")) return false; // Handled separately by split-landing code

    try {
        const url = new URL(link.href);
        // Check if same host
        if (url.host !== window.location.host) return false;

        // Check if it's just a hash change on the same page
        if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) {
            return false;
        }

        // It's a local page link, check if it's an HTML page or root
        const path = url.pathname;
        if (path === '/' || path.endsWith('.html') || path.endsWith('/')) {
            return true;
        }
    } catch (e) {
        // Invalid URL
    }
    return false;
}

// Quick Cart functions for Developer/Admin Mode
window.addVariantToQuickCart = function (cardId, variantId, event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }

    const card = tcgInventory.find(c => c.id === cardId);
    if (!card) return;

    let variantName = card.name;
    let variantPrice = card.basePrice || 0;
    let variantCondition = card.condition || 'Raw';
    let variantStock = card.stock !== undefined ? card.stock : 0;
    let variantImg = card.image || '';

    if (variantId && card.variants) {
        const variant = card.variants.find(v => v.id === variantId);
        if (variant) {
            variantPrice = variant.price || 0;
            variantCondition = normalizeCondition(variant.option1) || variant.option1;
            variantStock = variant.stock !== undefined ? variant.stock : 0;
            if (variant.image) {
                variantImg = typeof variant.image === 'string' ? variant.image : (variant.image.src || variantImg);
            }
        }
    }

    if (variantStock <= 0) {
        if (typeof showToast === 'function') {
            showToast("Error", "Out of stock variant cannot be added to quick cart", true);
        }
        return;
    }

    // Find existing item in quick cart
    const existing = window.quickCartItems.find(item => item.cardId === cardId && item.variantId === variantId);
    if (existing) {
        existing.qty += 1;
        if (!existing.image && variantImg) existing.image = variantImg;
    } else {
        window.quickCartItems.push({
            cardId,
            variantId,
            qty: 1,
            name: variantName,
            condition: variantCondition,
            price: variantPrice,
            image: variantImg || card.image || ''
        });
    }

    window.renderQuickCart();
};

window.renderQuickCart = function () {
    const container = document.getElementById("admin-quick-cart-items");
    const totalEl = document.getElementById("quick-cart-total");
    const countEl = document.getElementById("quick-cart-count");
    if (!container || !totalEl) return;

    const totalQty = window.quickCartItems.reduce((acc, item) => acc + item.qty, 0);
    if (countEl) countEl.textContent = totalQty;

    if (window.quickCartItems.length === 0) {
        container.innerHTML = `<div class="empty-quick-cart"><i class="fa-solid fa-cart-arrow-down" style="font-size: 1.6rem; opacity: 0.35; margin-bottom: 8px; display: block;"></i>Click variant pills to add items to Quick Cart</div>`;
        totalEl.textContent = "$0.00";
        return;
    }

    let total = 0;
    container.innerHTML = window.quickCartItems.map((item, idx) => {
        const itemTotal = item.price * item.qty;
        total += itemTotal;
        const cardMatch = (typeof tcgInventory !== "undefined" && tcgInventory) ? tcgInventory.find(c => c.id === item.cardId) : null;
        const imgUrl = item.image || (cardMatch ? cardMatch.image : '');
        const escapedItemName = escapeHtml(item.name);
        const escapedCond = escapeHtml(item.condition);
        return `
            <div class="quick-cart-item">
                <div class="quick-cart-item-thumb">
                    ${imgUrl ? `<img src="${imgUrl}" alt="${escapedItemName}" loading="lazy" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" /><div class="quick-cart-no-img" style="display:none;"><i class="fa-solid fa-image"></i></div>` : `<div class="quick-cart-no-img"><i class="fa-solid fa-image"></i></div>`}
                </div>
                <div class="quick-cart-item-info">
                    <div class="quick-cart-item-row">
                        <span class="quick-cart-item-name" title="${escapedItemName}">${escapedItemName}</span>
                        <button class="quick-cart-remove-btn" data-idx="${idx}" title="Remove item"><i class="fa-solid fa-trash-can"></i></button>
                    </div>
                    <div class="quick-cart-item-meta">
                        <span class="quick-cart-item-badge">${escapedCond}</span>
                        <span class="quick-cart-item-unit-price">$${item.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                    <div class="quick-cart-item-qty-row">
                        <div class="quick-cart-qty-controls">
                            <button class="quick-cart-qty-btn" data-idx="${idx}" data-change="-1" title="Decrease quantity">-</button>
                            <span class="quick-cart-qty-val">${item.qty}</span>
                            <button class="quick-cart-qty-btn" data-idx="${idx}" data-change="1" title="Increase quantity">+</button>
                        </div>
                        <span class="quick-cart-item-subtotal">$${itemTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    totalEl.textContent = `$${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

window.updateQuickCartQty = function (index, change) {
    if (index >= 0 && index < window.quickCartItems.length) {
        window.quickCartItems[index].qty += change;
        if (window.quickCartItems[index].qty <= 0) {
            window.quickCartItems.splice(index, 1);
        }
        window.renderQuickCart();
    }
};

window.removeQuickCartItem = function (index) {
    if (index >= 0 && index < window.quickCartItems.length) {
        window.quickCartItems.splice(index, 1);
        window.renderQuickCart();
    }
};

window.calculateInventoryValues = function () {
    let totalValue = 0;
    let exVictorValue = 0;

    const items = (typeof tcgInventory !== "undefined" && tcgInventory) ? tcgInventory : [];
    items.forEach(product => {
        let prodVal = 0;
        if (product.variants && product.variants.length > 0) {
            product.variants.forEach(v => {
                const stock = v.stock !== undefined ? Math.max(0, v.stock) : 0;
                const price = v.price || 0;
                prodVal += stock * price;
            });
        } else {
            const stock = product.stock !== undefined ? Math.max(0, product.stock) : 0;
            const price = product.basePrice || 0;
            prodVal += stock * price;
        }

        totalValue += prodVal;

        const isVictor = product.tags && product.tags.some(t => t.toLowerCase() === 'victor');
        if (!isVictor) {
            exVictorValue += prodVal;
        }
    });

    const totalEl = document.getElementById("admin-inventory-total-value");
    const exVictorEl = document.getElementById("admin-inventory-ex-victor-value");

    if (totalEl) {
        totalEl.textContent = `$${totalValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
    if (exVictorEl) {
        exVictorEl.textContent = `$${exVictorValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
};
